// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 5%27%3E%3Cpath fill=%27%23495057%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
*/ body {
  position: relative;
}

section {
  padding: 0 0.6rem;
}

.dashtext-1 {
  color: #864dd9 !important;
}

.dashtext-2 {
  color: #cf53f9 !important;
}

.dashtext-3 {
  color: #e95f71 !important;
}

.dashtext-4 {
  color: #7127ac !important;
}

.dashbg-1 {
  background: #864dd9;
}

.dashbg-2 {
  background: #cf53f9;
}

.dashbg-3 {
  background: #e95f71;
}

.dashbg-4 {
  background: #7127ac;
}

.text-bold {
  font-weight: 700;
}

.text-small {
  font-size: 0.8rem;
}

.text-gray-light {
  color: #dee2e6;
}

.text-gray {
  color: #8a8d93;
}

.text-gray-dark {
  color: #6a6c70;
}

.text-black {
  color: #000;
}

.text-uppercase {
  letter-spacing: 0.1em;
}

.lh-2 {
  line-height: 2;
}

.list-group-item {
  border-right: 0;
  border-left: 0;
}

.list-group-item:first-child,
.list-group-item:last-child {
  border-radius: 0;
}

.overflow-hidden {
  overflow: hidden;
}

.tile-link {
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 30;
}

p {
  line-height: 1.7;
}

button {
  cursor: pointer;
  background-color: transparent;
  border: none;
}

i,
span,
strong {
  display: inline-block;
}

input {
  outline: none;
}

pre {
  color: #8a8d93;
}

.dropdown-divider {
  border-top-color: #6a6c70;
}

.no-padding {
  padding: 0 !important;
}

.no-padding-top {
  padding-top: 0 !important;
}

.no-padding-bottom {
  padding-bottom: 0 !important;
}

.no-margin {
  margin: 0 !important;
}

.no-margin-top {
  margin-top: 0 !important;
}

.no-margin-bottom {
  margin-bottom: 0 !important;
}

.padding-top-sm {
  padding-top: 30px !important;
}

.padding-bottom-sm {
  padding-bottom: 30px !important;
}

.margin-top-sm {
  margin-top: 30px !important;
}

.margin-bottom-sm {
  margin-bottom: 30px !important;
}

.breadcrumb {
  background: none;
  padding: 20px 20px;
  margin-bottom: 0;
  color: #8a8d93;
}

.breadcrumb a {
  color: #2186AD;
  text-decoration: none !important;
}

.breadcrumb li.active {
  color: #585a5f;
}

.breadcrumb-item+.breadcrumb-item::before {
  color: #585a5f;
}

.block {
  padding: 20px;
  background: #fff;
  color: #000000;
  border: 1px solid #E8E8E8;
  border-radius: 4px;
  margin-bottom: 30px;
}

.card {
  margin-bottom: 30px;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1), -1px 0 2px rgba(0, 0, 0, 0.05);
}

.card-header h1,
.card-header h2,
.card-header h3,
.card-header h4,
.card-header h5,
.card-header h6 {
  margin-bottom: 0;
}

.page-content {
  position: relative;
  /* background: #ECEEF2; */
  min-height: calc(100vh - 73px);
  width: calc(100% - 222px);
  padding: 0 28px;
  padding-bottom: 70px;
}

.page-content.active {
  width: 100%;
}

.page-header {
  padding: 20px 15px;
  background: rgb(84, 178, 203);
  color: #fff;
  margin-bottom: 30px;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.footer .footer__block {
  min-height: 70px;
}

.dropdown-menu {
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  font-size: 1rem;
  min-width: 200px;
  background: #fff;
  border-radius: 2.5px;
  padding: 0;
  margin-top: 8px;
  border: 1px solid #f4f4f4;
}

.dropdown-menu a {
  color: inherit;
}

.dropdown-toggle {
  background: none;
  outline: none;
  border-radius: 0;
}

.dropdown-toggle span.caret {
  color: #555;
}

.dropdown-menu a {
  padding: 10px 15px;
  font-size: 0.9rem;
  text-transform: none;
}

.dropdown-submenu {
  position: relative;
}

.dropdown-submenu>.dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -2px;
  font-size: 1rem;
}

.megamenu {
  width: 100%;
  padding: 40px 30px;
  margin-top: 0 !important;
  z-index: 1100 !important;
}

.megamenu strong {
  margin-bottom: 10px;
  display: block;
}

.megamenu ul {
  padding: 0;
  margin: 0;
}

.megamenu ul a {
  padding: 5px 0 !important;
  text-decoration: none;
  color: #555;
  font-size: 0.9em !important;
}

.megamenu ul a:hover {
  background: none;
  color: #2186AD !important;
}

.megamenu .megamenu-buttons {
  color: #fff;
  margin-top: 40px;
}

.megamenu .megamenu-buttons .megamenu-button-link {
  padding: 20px !important;
  text-decoration: none;
  font-weight: 300;
}

.megamenu .megamenu-buttons .megamenu-button-link.dashbg-1:hover {
  background: #7838d5 !important;
}

.megamenu .megamenu-buttons .megamenu-button-link.dashbg-2:hover {
  background: #c83af8 !important;
}

.megamenu .megamenu-buttons .megamenu-button-link.dashbg-3:hover {
  background: #e6495d !important;
}

.megamenu .megamenu-buttons .megamenu-button-link.dashbg-4:hover {
  background: #632297 !important;
}

.block .title {
  margin-bottom: 20px;
}

.block .title strong:first-child {
  font-size: 1.25rem;
  color: #a5a7ab;
}

.block .title span:first-child {
  font-weight: 300;
  font-size: 0.95rem;
}

/*
* ==========================================================
*     NAVBAR
* ==========================================================
*/
/* nav.navbar {
  background:#131517;
  color: #fff;
  padding: 0;
  border-bottom: none;
  box-shadow:none;
  z-index: 10;
  border-bottom: 1px solid #2D3034;
} */

nav.navbar .sidebar-toggle {
  width: 36px;
  height: 36px;
  text-align: center;
  border-radius: 0%;
  background: none;
  border: none;
  outline: none;
  position: relative;
  margin: 0 10px 0 0px;
  padding: 0;
  border: none;
}

nav.navbar .sidebar-toggle .toggle-icon {
  width: 22px;
  position: relative;
  display: block;
  height: 2px;
  background: #707070;
  border-radius: 4px;
}

nav.navbar .sidebar-toggle .toggle-icon:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: -7px;
  height: 2px;
  background: #707070;
  border-radius: 4px;
  transition: 0.25s ease-out;
}

nav.navbar .sidebar-toggle .toggle-icon:after {
  content: "";
  position: absolute;
  left: 0;
  right: 10px;
  top: 7px;
  height: 2px;
  background: #707070;
  border-radius: 4px;
  transition: 0.25s ease-out;
}

.sideMenuFixed nav.navbar .sidebar-toggle .toggle-icon:before {
  transform: rotate(-35deg);
  left: -1px;
  width: 15px;
  right: auto;
  top: -4.3px;
}

.sideMenuFixed nav.navbar .sidebar-toggle .toggle-icon:after {
  transform: rotate(35deg);
  left: -1px;
  width: 15px;
  right: auto;
  top: 4.4px;
}

nav.navbar a {
  color: inherit;
}

nav.navbar .brand-text {
  display: none;
  font-weight: 700;
}

nav.navbar .brand-text.visible {
  display: block;
}

nav.navbar a.nav-link {
  padding: 0.5rem 0.3rem;
  position: relative;
}

nav.navbar .nav-link .badge {
  width: 10px;
  height: 10px;
  text-align: center;
  border-radius: 50%;
  padding: 0;
  font-size: 0.7rem;
  position: absolute;
  top: 1px;
  right: 12px;
  background: #DD0A0A;
}

nav.navbar .messages-toggle,
nav.navbar .tasks-toggle {
  margin-right: 15px;
}

nav.navbar .menu-large {
  position: static !important;
}

nav.navbar .search-panel {
  display: none;
}

nav.navbar .search-inner {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(45, 48, 53, 0.95);
  z-index: 9;
}

nav.navbar .search-inner .close-btn {
  position: absolute;
  top: 20px;
  right: 40px;
  font-size: 1.1em;
  font-weight: 400;
  cursor: pointer;
}

nav.navbar .search-inner form {
  width: 100%;
  max-width: 800px;
  padding: 20px;
}

nav.navbar .search-inner .form-group {
  position: relative;
}

nav.navbar .search-inner .submit {
  background: none;
  font-size: 2.3rem;
  position: absolute;
  right: 0;
  bottom: 0;
  color: #8a8d93;
  border: none;
  font-weight: 700 !important;
}

nav.navbar .search-inner input {
  background: none;
  width: 100%;
  font-size: 2rem;
  border: none;
  border-bottom: 1px solid #444951;
  color: #8a8d93;
}

nav.navbar .search-inner input::-moz-placeholder {
  color: #585a5f;
}

nav.navbar .search-inner input::-webkit-input-placeholder {
  /* font-family: "Muli", sans-serif;
  font-weight: 300 !important; */
  color: #535353;
}

nav.navbar .search-inner input:-ms-input-placeholder {
  /* font-family: "Muli", sans-serif; 
  font-weight: 300 !important; */
  color: #535353;
}

nav.navbar .dropdown-menu {
  min-width: 300px;
  left: auto;
  right: 0;
  inset-inline-start: auto !important;
}

nav.navbar .dropdown-item {
  padding: 1rem;
  border-bottom: 1px solid rgba(112, 112, 112, 0.16);
}

nav.navbar .dropdown-item:hover {
  background: #EDEDED;
  color: #000;
}

nav.navbar .dropdown-item:last-of-type {
  border-bottom: none;
}

nav.navbar .dropdown-item.message {
  color: #464646;
  text-decoration: none;
}

nav.navbar .dropdown-item.message li:last-of-type a {
  border-bottom: none;
}

nav.navbar .dropdown-item.message .profile {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 15px;
  position: relative;
}

nav.navbar .dropdown-item.message .profile img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

nav.navbar .dropdown-item.message .profile .status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: absolute;
  top: 2px;
  right: 2px;
}

nav.navbar .dropdown-item.message .profile .status.online {
  background: #28a745;
}

nav.navbar .dropdown-item.message .profile .status.away {
  background: #ffc107;
}

nav.navbar .dropdown-item.message .profile .status.busy {
  background: #dc3545;
}

nav.navbar .dropdown-item.message .profile .status.offline {
  background: #999;
}

nav.navbar .dropdown-item.message .content strong {
  font-size: 1rem;
}

nav.navbar .dropdown-item.message .content span {
  font-weight: 300;
  font-size: 0.85rem;
}

nav.navbar .dropdown-item.message .content .date {
  color: #70737a;
}

nav.navbar .tasks-list strong {
  font-size: 1rem;
}

nav.navbar .tasks-list span {
  font-size: 0.95rem;
}

nav.navbar .tasks-list .progress {
  height: 2px;
  margin-top: 10px;
  background: #444951;
}

nav.navbar a.language span {
  margin-left: 0.2rem;
  vertical-align: middle;
}

/* Navbar dropdown effect */


nav.navbar .dropdown .dropdown-menu.active {
  transform: translateY(0);
}

/* Navbar Media Query ----------------------------------- */
@media (max-width: 1331px) {
  nav.navbar .right-menu {
    margin-bottom: -3px;
  }

  nav.navbar .navbar-brand {
    margin-right: 5px;
  }

  nav.navbar .search-inner form input {
    font-size: 1.25rem !important;
  }

  nav.navbar .search-inner form button.submit {
    position: absolute;
    font-size: 2rem;
    top: 50px;
    display: block;
    width: 100%;
  }

  nav.navbar .brand-text {
    display: none !important;
  }

  nav.navbar .brand-text.visible {
    display: none !important;
  }

  nav.navbar .brand-text.brand-sm {
    display: block !important;
  }
}

@media (max-width: 991px) {
  nav.navbar .dropdown-menu {
    right: -140px;
  }

  nav.navbar .megamenu {
    right: 0 !important;
  }

  nav.navbar a.nav-link {
    font-size: 0.85rem;
  }

  nav.navbar .nav-link .badge {
    width: 16px;
    height: 16px;
    line-height: 16px;
    color: #fff;
    text-align: center;
    font-size: 0.6rem;
  }
}

@media (max-width: 575px) {
  nav.navbar .dropdown {
    position: static;
  }

  nav.navbar .dropdown-menu {
    width: 90vw;
    right: 2.5vw;
    left: 2.5vw;
    margin: 0 auto;
  }


}

/*
* ==========================================================
*     SIDEBAR
* ==========================================================
*/
nav#sidebar {
  width: 240px;
  /* margin-top: 60px; */
  background:#1a1c1f;
  color: #0e1115;
  border-right: 1px solid #2D3034;
  /* shrinked navbar */
  /* background-color: #fff; */
  position: relative;
  padding-bottom: 90px;
  
}

nav#sidebar a {
  color: inherit;
  text-decoration: none;
  position: relative;
}

nav#sidebar a[aria-haspopup="menu"]::after,
nav#sidebar button[aria-haspopup="menu"]::after {
  content: "\\e901";
  display: inline-block;
  transform: translateY(-50%);
  font-family: 'icomoon' !important;
  position: absolute;
  top: 50%;
  right: 20px;
  font-size: 11px;
}

nav#sidebar a[aria-haspopup="menu"][aria-expanded="true"]::after,
nav#sidebar button[aria-haspopup="menu"][aria-expanded="true"]::after {
  transform: translateY(-50%) rotate(180deg);
}


nav#sidebar.shrinked a[aria-haspopup="menu"]::after {
  content: "\\f107";
  transform: translate(-50%, -50%);
  position: absolute;
  top: 90%;
  left: 50%;
}

nav#sidebar.shrinked a[aria-haspopup="menu"][aria-expanded="true"]::after {
  content: "\\f106";
}

nav#sidebar span.heading {
  font-weight: 700;
  margin-left: 20px;
  color: #494d53;
  font-size: 1.2rem;
  margin-bottom: 15px;
}

nav#sidebar .avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 15px;
  background: none;
  padding: 4px;
}

nav#sidebar.shrinked .avatar {
  margin-right: 0px;
}

nav#sidebar ul {
  max-height: none;
  padding-bottom: 0px;
}

nav#sidebar li {
  position: relative;
  margin: 0px;
}

nav#sidebar li a {
  padding: 12px 12px;
  display: block;
  font-size: 15px;
  font-weight: 400;
  position: relative;
  z-index: 1;
  border: none;
  color: #7B7A7A;
  line-height: normal;
  border-radius: 3px;
  display: flex;
  align-items: center;
}


nav#sidebar li a .icon, nav#sidebar li>.btn.sgds .icon {
    margin: 0 7px 0 0;
    font-size: 16px;
    flex: 0 0 20px;
}

nav#sidebar li a .icon svg.menu-item-icon {
    height: 19px;
    width: auto;
}

nav#sidebar li a .icon.icon-user-management, nav#sidebar li a .icon.icon-team-management,  nav#sidebar li a .icon.icon-profile-settings, 
nav#sidebar li a .icon.icon-help, nav#sidebar li a .icon.icon-settings {
   font-size: 17px;
}

nav#sidebar li a .icon.icon-leaderboard{
  font-size: 18px;
}

nav#sidebar li a:hover {
  color: #ed5a28;
}


nav#sidebar li a:focus {
  box-shadow: none;
}

nav#sidebar li a[aria-expanded="true"]:before {
  opacity: 1;
}


nav#sidebar li.selected .sidenav-collapse li a.active:before,
nav#sidebar li.selected .sidenav-collapse li a.active:hover:before {
  background: #10688B;
  opacity: 1;
}

#sidebar .sidenav-collapse {
  margin: 0px;
}

nav#sidebar li.active>a {
    background: rgb(230 113 37 / 18%);
    color: #ed5a28;
    font-weight: 600;
}

nav#sidebar li li.active>a {
  background: rgb(84, 178, 203);
}

nav#sidebar li>.btn.sgds {
  padding: 12px 12px;
  font-size: 15px;
  font-weight: 400;
  position: relative;
  z-index: 1;
  border: none;
  color: #7B7A7A;
  line-height: normal;
  border-radius: 3px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
}

nav#sidebar li.active>.btn.sgds {
    background: rgba(3, 189, 90, 0.18);
    color: #0CA751;
    font-weight: bold;
}

nav#sidebar li>.btn.sgds:focus {
    outline: none;
    box-shadow: none;
}

nav#sidebar li.active>.btn.sgds .icon-traininig {
  font-size: 18px;
}

nav#sidebar li .sidenav-collapse ul li a {
    font-size: 14px;
    padding: 9px 12px 9px 20px;
}

nav#sidebar.shrinked {
  width: 80px;
}


nav#sidebar.shrinked span.heading {
  margin-left: 0;
  display: block;
  text-align: center;
  font-size: 1rem;
}

nav#sidebar.shrinked ul {
  max-height: none;
}

nav#sidebar.shrinked ul a {
  padding: 14px 5px;
  display: block;
  font-weight: 400;
  text-align: center;
  font-size: 0.8rem;
  word-break: break-word;
}

nav#sidebar.shrinked ul i {
  font-size: 1.2rem;
  text-align: center !important;
  width: 100%;
  display: block !important;
  border: none !important;
  padding: 0 !important;
}

nav#sidebar.shrinked ul ul a {
  padding-left: 10px;
}

nav#sidebar.shrinked a[data-bs-toggle="collapse"]::after {
  content: "\\f107";
  transform: translate(-50%, -50%);
  position: absolute;
  top: 88%;
  left: 50%;
}

nav#sidebar.shrinked a[aria-expanded="true"]::after {
  content: "\\f106";
}

/* Sidebar Media Query ----------------------------------- */

@media (min-width: 991px) {
  nav#sidebar {
    transition: margin, 0.25s ease-out;
    margin-left: 0px;
    flex: 0 0 240px;
  }

  .sideMenuFixed nav#sidebar {
    margin-left: 0px;
  }

  nav#sidebar+.page-content {
    /* width: auto; */
    flex: auto;
  }


  /* nav.navbar .sidebar-toggle {
    display: none;
  } */

}

@media (max-width: 991px) {
  .page-content {
    width: 100%;
  }

  .page-content.active {
    width: calc(100% - 80px);
  }

  nav#sidebar {
    /* width: 15%; */
    margin-left: 0px;
    flex: 0 0 222px;
    position: fixed;
    left: -222px;
    top: 68.79px;
    bottom: 0;
    transition: left, 0.25s ease-out;
    z-index: 99;
  }

  .sideBarSticky {
    height: calc(100vh - 73px);
    overflow-y: auto;
  }

  .sideMenuFixed nav#sidebar {
    left: 0;
  }



  nav#sidebar li a {
    padding: 16px 18px;
    font-size: 14px;
  }

  nav#sidebar li a i,
  nav#sidebar li button.btn i {
    margin: -2px 7px 0px 0;
  }

  nav.navbar .dropdown {
    border-left: none;
    margin-left: 8px;
  }

  nav.navbar .sidebar-toggle {
    margin: 0 0 0 10px;
  }



  nav#sidebar span.heading {
    margin-left: 0;
    display: block;
    text-align: center;
    font-size: 1rem;
  }

  nav#sidebar ul {
    max-height: none;
  } 
}

@media (min-width: 991px) {
  .statistic-block {
    padding: 20px;
    background: #fff;
    color: #000000;
    border: 1px solid #E8E8E8;
  }

  .statistic-block .title {
    margin-bottom: 0;
  }

  .statistic-block strong,
  .statistic-block span {
    display: block;
  }

  .statistic-block strong {
    text-transform: none;
    letter-spacing: 0.1em;
    font-size: 0.9rem;
    color: #8a8d93;
    margin-bottom: 5px;
  }

  .statistic-block .icon {
    margin-bottom: 5;
    font-size: 1.2rem;
    color: #8a8d93;
  }

  .statistic-block .number {
    color: inherit;
    font-size: 2.2rem;
  }

  .progress-bar {
    background-color: #1D68E0;
  }

  .progress.progress-template {
    width: 100%;
    height: 4px;
    border-radius: 30px;
    overflow: hidden;
    background: #393c43;
    margin-top: 5px;
  }

  .progress.progress-template.progress-small {
    height: 2px;
  }

  .progress-bar.progress-bar-template {
    height: 4px;
    border-radius: 30px;
  }

  .progress-bar.progress-bar-template.progress-bar-small {
    height: 2px;
  }

 
  /* Scans Block */
  .stats-2-block .stats-2 {
    width: 50%;
    color: #8a8d93;
    position: relative;
    padding-right: 50px;
  }

  .stats-2-block .stats-2::after {
    content: "";
    background: #40444b;
    width: 1px;
    height: 80%;
    display: block;
    position: absolute;
    top: 10%;
    right: 30px;
  }

  .stats-2-block .stats-2:last-of-type {
    padding-right: 0;
  }

  .stats-2-block .stats-2:last-of-type::after {
    display: none;
  }

  .stats-2-block span,
  .stats-2-block strong {
    color: inherit;
  }

  .stats-2-block strong {
    font-size: 2rem;
  }

  .stats-2-block span {
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-weight: 300;
    font-size: 0.9rem;
  }

  .stats-2-block .progress {
    margin-top: 10px;
    max-width: 150px;
  }

  .stats-2-block .stats-2-arrow {
    transform: translateY(10px);
    margin-right: 10px;
  }

  .stats-2-block .stats-2-arrow.low {
    color: #dc3545;
  }

  .stats-2-block .stats-2-arrow.height {
    color: #28a745;
  }
}

/* Scans Block Media Query ------------------ */
@media (max-width: 991px) {
  .stats-2-block .stats-2::after {
    display: none;
  }
}

/* Requests Block */
.stats-3-block .stats-3 {
  width: 50%;
  color: #8a8d93;
  position: relative;
  padding-right: 50px;
}

.stats-3-block .stats-3::after {
  content: "";
  background: #40444b;
  width: 1px;
  height: 80%;
  display: block;
  position: absolute;
  top: 10%;
  right: 30px;
}

.stats-3-block .stats-3:last-of-type {
  padding-right: 0;
}

.stats-3-block .stats-3:last-of-type::after {
  display: none;
}

.stats-3-block span,
.stats-3-block strong {
  color: inherit;
}

.stats-3-block strong {
  font-size: 2rem;
}

.stats-3-block strong.strong-sm {
  font-size: 1.4rem;
}

.stats-3-block span {
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 300;
  font-size: 0.9rem;
  font-weight: 400;
}

.stats-3-block span.span-sm {
  font-size: 0.85rem;
}

.stats-3-block .progress {
  margin-top: 10px;
  background: #393c43;
  max-width: 150px;
}

.stats-3-block .item {
  width: 50%;
}

.stats-3-block .item .line {
  display: block;
  margin: 10px auto;
  width: 30px;
  height: 1px;
  background: #40444b;
}

.stats-3-block small {
  font-weight: 700;
}

/* Requests Block Media Query ------------------ */
@media (max-width: 991px) {
  .stats-3-block .stats-3::after {
    display: none;
  }
}


/* user block */
.user-block .avatar {
  display: block;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin: 15px auto;
  position: relative;
}

.user-block .avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.user-block .avatar .order {
  width: 22px;
  height: 22px;
  line-height: 23px;
  border-radius: 50%;
  color: #fff;
  position: absolute;
  bottom: 0px;
  right: 0px;
  font-size: 0.7rem;
}

.user-block h3 {
  margin-bottom: 0;
}

.user-block span {
  font-weight: 300;
  color: #75787f;
}

.user-block .contributions {
  margin-top: 20px;
  border-radius: 50px;
  padding: 6px 30px;
  background: #26292d;
  display: inline-block;
  font-size: 0.9rem;
}

.user-block .details {
  margin-top: 40px;
}

.user-block .item {
  width: 33.3333%;
  text-align: center;
}

.user-block .item i {
  margin-right: 10px;
  color: #6a6c70;
}

.user-block a.user-title {
  display: block;
  text-decoration: none;
  color: #8a8d93;
  margin-top: 10px;
}

/* Public user Block */
.public-user-block .avatar {
  min-width: 50px;
  max-width: 50px;
  min-height: 50px;
  max-height: 50px;
  border-radius: 50%;
  margin-left: 15px;
  margin-right: 15px;
  position: relative;
  overflow: hidden;
}

.public-user-block .avatar img {
  width: 100%;
  height: 100%;
}

.public-user-block strong {
  font-size: 1.2rem;
}

.public-user-block span {
  font-size: 0.9rem;
  font-weight: 300;
}

.public-user-block .contributions {
  border-radius: 50px;
  padding: 6px 30px;
  background: #26292d;
  display: inline-block;
  font-size: 0.9rem;
}

.public-user-block .item {
  width: 33.3333%;
  text-align: center;
}

.public-user-block .item i {
  margin-right: 10px;
  color: #6a6c70;
}

.public-user-block .item strong {
  font-size: 0.9rem;
}

.public-user-block .order {
  font-size: 0.9rem;
  font-weight: 700;
}

.public-user-block a.name {
  text-decoration: none;
  color: #8a8d93;
}

/* Public users Block Media Query ------------------ */
@media (max-width: 991px) {
  .public-user-block .contributions {
    margin: 20px 0;
  }

  .public-user-block .order {
    display: none !important;
  }
}

/*
* ==========================================================
*     SALES SECTION
* ==========================================================
*/
/* Sale Block */
.stats-with-chart-2 .title {
  margin-bottom: 30px;
}

.stats-with-chart-2 .title strong {
  font-size: 1.25rem;
}

.stats-with-chart-2 .title span {
  font-weight: 300;
  font-size: 0.95rem;
}

.stats-with-chart-2 .chart {
  position: relative;
  margin-bottom: 20px;
}

.stats-with-chart-2 .text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
  text-align: center;
}

.stats-with-chart-2 .text strong {
  font-size: 1.5rem;
}

.stats-with-chart-2 .text span {
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 300;
}

/* Sales Difference Block */
.stats-with-chart-1 {
  height: 100%;
}

.stats-with-chart-1 .title {
  margin-bottom: 30px;
}

.stats-with-chart-1 .title strong {
  font-size: 1.25rem;
}

.stats-with-chart-1 .title span {
  font-weight: 300;
  font-size: 0.95rem;
}

.stats-with-chart-1 .text strong {
  font-size: 1.8rem !important;
  font-weight: 300;
}

/* Sales Difference Block Media Query ------------------ */
@media (max-width: 991px) {
  .stats-with-chart-1 {
    height: auto;
  }
}

/*
* ==========================================================
*     FEEDS SECTION
* ==========================================================
*/
/* Checklist Media Query */
.checklist-block .title {
  margin-bottom: 20px;
}

.checklist-block .title strong {
  font-size: 1.25rem;
}

.checklist-block .title span {
  font-weight: 300;
  font-size: 0.95rem;
}

.checklist-block label {
  font-size: 0.9rem;
  color: #8a8d93;
  line-height: 1.8em;
  margin-bottom: 0;
}

.checklist-block .item {
  padding: 26px;
}

.checklist-block .item:nth-of-type(even) {
  background: #282b2f;
}

.checklist-block input:checked+label {
  text-decoration: line-through;
}

/* Messages Media Query */
.messages-block a.message {
  color: #8a8d93;
  text-decoration: none;
  padding: 10px;
  border-bottom: 1px solid #282b2f;
}

.messages-block a.message:hover {
  background: #282b2f;
}

.messages-block a.message:last-of-type {
  border-bottom: none;
}

.messages-block .title {
  margin-bottom: 30px;
}

.messages-block .title strong {
  font-size: 1.25rem;
}

.messages-block .title span {
  font-weight: 300;
  font-size: 0.95rem;
}

.messages-block .profile {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 15px;
  position: relative;
}

.messages-block .profile img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.messages-block .profile .status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: absolute;
  top: 2px;
  right: 2px;
}

.messages-block .profile .status.online {
  background: #28a745;
}

.messages-block .profile .status.away {
  background: #ffc107;
}

.messages-block .profile .status.busy {
  background: #dc3545;
}

.messages-block .profile .status.offline {
  background: #999;
}

.messages-block .content strong {
  font-size: 1.1rem;
}

.messages-block .content span {
  font-weight: 300;
}

.messages-block .content .date {
  color: #70737a;
}

/* Modal */
.modal-open .modal {
  z-index: 9999;
}

.modal-open .modal .modal-content {
  border-radius: 4px;
}

.modal .modal-header {
  padding-top: 24px;
  padding-top: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
}



.modal-open .modal .close {
  color: #8a8d93;
  opacity: 1;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}


.modal-content .modal-header .btn-close {
  padding: 0;
  margin: 0 -10px 0 0;
  width: 30px;
  height: 30px;
  background: none;
  opacity: 1;
  background: #E5E5E5;
}

.modal .modal-content .modal-body {
  padding: 28px 26px;
}

.modal-content .modal-header .btn-close:before {
  content: "\\e90e";
  font-family: 'icomoon' !important;
  color: #000;
  font-size: 11px;
}



/*
* ==========================================================
*       UTILITIES
* ==========================================================
*/
.bg-cover {
  background-size: cover;
}

.bg-gray-dark {
  background: #2d3035;
}

.bg-gray-darker {
  background: #22252a;
}

/*
* ==========================================================
*     FORMS
* ==========================================================
*/
.form-control {
  /* height: calc(2.4rem + 2px); */
  border: 1px solid #444951;
  background: transparent;
  border-radius: 0;
  color: #979a9f;
  /* padding: 0.45rem 0.75rem; */
}

.form-control::-moz-placeholder {
  font-size: 0.9rem;
  /* font-family: "Muli", sans-serif; */
  color: #535353;
}

.form-control::-webkit-input-placeholder {
  font-size: 0.9rem;
  /* font-family: "Muli", sans-serif; */
  color: #535353;
}

.form-control:-ms-input-placeholder {
  font-size: 0.9rem;
  /* font-family: "Muli", sans-serif; */
  color: #535353;
}

.form-control:focus {
  color: #979a9f;
  background-color: transparent;
  border-color: #2186AD;
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(219, 101, 116, 0.25);
}

.form-control:focus {
  box-shadow: none;
}

.form-control:disabled,
.form-control[readonly] {
  background: #444951;
}

.form-control-sm {
  height: calc(1.8125rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.form-control-lg {
  height: calc(2.875rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
}

.form-control-label {
  color: #777;
  margin: 8px 0px;
}

button,
input[type="submit"] {
  cursor: pointer;
  font-family: inherit;
  /* font-weight: 300 !important; */
}

.custom-select {
  height: calc(2.4rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  line-height: 1.5;
  color: #8a8d93;
  vertical-align: middle;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 0.75rem center;
  background-size: 8px 10px;
  border: 1px solid #444951;
  border-radius: 0;
  appearance: none;
}

.custom-select:focus {
  border-color: #2186AD;
  outline: 0;
  box-shadow: none;
}

.custom-select:focus::-ms-value {
  color: #495057;
  background-color: transparent;
}

.custom-select[multiple],
.custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}

.custom-select:disabled {
  color: #868e96;
  background-color: #e9ecef;
}

.custom-select::-ms-expand {
  opacity: 0;
}

.custom-select-sm {
  height: calc(1.8125rem + 2px);
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 75%;
}

.custom-select-lg {
  height: calc(2.875rem + 2px);
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 125%;
}

.input-group-text {
  background: #363a40;
  color: #8a8d93;
  font-weight: 300;
  border-radius: 0;
  border: 1px solid #444951;
  line-height: 1.5rem;
}

.input-group-text .checkbox-template,
.input-group-text .radio-template {
  transform: none;
}

.input-group .dropdown-menu {
  padding: 15px;
  color: #777;
  border-radius: 0;
  margin-top: 5px;
}

.input-group .dropdown-menu a {
  padding: 5px 0;
  color: inherit;
  text-decoration: none;
  display: block;
}

.input-group .dropdown-menu a:hover {
  color: #2186AD;
  background: none !important;
}

form label {
  font-size: 0.9rem;
  color: #8a8d93;
  margin: 8px 0;
}

.checkbox-template,
.radio-template {
  transform: translateY(1px);
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  position: relative;
  outline: none;
}

.checkbox-template+label,
.radio-template+label {
  margin-left: 15px;
}

.checkbox-template::before,
.radio-template::before {
  margin-right: 10px;
  content: "";
  display: inline-block;
  transform: translate(-2px, -2px);
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background: #8a8d93;
  transition: all 0.2s;
}

.checkbox-template::after,
.radio-template::after {
  content: "\\f00c";
  width: 12px;
  height: 12px;
  line-height: 12px;
  text-align: center;
  display: block;
  font-family: "FontAwesome";
  position: absolute;
  top: 1px;
  left: 1px;
  font-size: 0.6rem;
  opacity: 0;
  transition: all 0.2s;
  color: #fff;
}

.checkbox-template:checked::before,
.radio-template:checked::before {
  background: #2186AD;
}

.checkbox-template:checked::after,
.radio-template:checked::after {
  opacity: 1;
}

.radio-template::before {
  border-radius: 50%;
  transform: translate(-3px, -3px);
}

.radio-template::after {
  width: 6px;
  height: 6px;
  line-height: 6px;
  text-align: center;
  position: absolute;
  top: 3px;
  left: 3px;
  border-radius: 50%;
  content: "";
}

.radio-template:checked::after {
  background: #fff;
}

input.input-material {
  width: 100%;
  border: none;
  border-bottom: 1px solid #444951;
  padding: 10px 0;
  background: none;
  color: #8a8d93;
}

input.input-material.is-invalid {
  border-color: #bb414d !important;
}

input.input-material:focus {
  border-color: #2186AD;
}

input.input-material~label {
  color: #aaa;
  position: absolute;
  top: 14px;
  left: 0;
  cursor: text;
  transition: all 0.2s;
  font-weight: 300;
}

input.input-material~label.active {
  font-size: 0.85rem;
  top: -10px;
  color: #2186AD;
}

input.input-material~label.is-invalid~label {
  color: #bb414d;
}

.form-group-material {
  position: relative;
  margin-bottom: 30px;
}

.custom-select.is-invalid:focus,
.form-control.is-invalid:focus,
.was-validated .custom-select:invalid:focus,
.was-validated .form-control:invalid:focus,
.custom-select.is-valid:focus,
.form-control.is-valid:focus,
.was-validated .custom-select:valid:focus,
.was-validated .form-control:valid:focus {
  box-shadow: none;
}

.form-page .block {
  margin-bottom: 30px;
}

/*
* ==========================================================
*     CHARTS
* ==========================================================
*/
.gauge-container {
  position: relative;
}

.gauge-canvas {
  display: block;
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
}

.gauge-label {
  display: inline-block;
  position: absolute;
  left: 50%;
  bottom: 50px;
  font-size: 1.2rem;
  transform: translateX(-50%);
}

.sparklines {
  display: inline-block;
  margin-left: 20px;
}

/*
* ==========================================================
*     TABLES
* ==========================================================
*/
.table {
  margin-bottom: 20px;
  color: #8a8d93;
}

.table td,
.table th {
  border-color: #C9C7C7;
}

.table thead th {
  border: none;
}

.table-striped tbody tr {
  transition: all 0.3s;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #282b2f;
  color: #8a8d93 !important;
}

.table-striped tbody tr:nth-of-type(odd):hover {
  background-color: #26292d;
}

.table-bordered td,
.table-bordered th {
  border-color: #C9C7C7;
}

@media (max-width: 991px) {
  section.tables {
    padding: 0;
  }
}

/*
=====================
STYLE SWITCHER FOR DEMO
=====================
*/
#style-switch-button {
  position: fixed;
  top: 120px;
  right: 0px;
  border-radius: 0;
  z-index: 2;
}

#style-switch {
  width: 300px;
  padding: 20px;
  position: fixed;
  top: 160px;
  right: 0;
  background: #22252a;
  border: solid 1px #6a6c70;
  z-index: 2000;
}

/* =========================================
   THEMING OF BOOTSTRAP COMPONENTS
   ========================================= */
/*
 * 1. NAVBAR
 */
.navbar {
  padding: 0.5rem 1rem;
}

.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-brand:focus,
.navbar-light .navbar-brand:hover {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-light .navbar-nav .nav-link:focus,
.navbar-light .navbar-nav .nav-link:hover {
  color: rgba(0, 0, 0, 0.7);
}

.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}

.navbar-light .navbar-nav .show>.nav-link,
.navbar-light .navbar-nav .active>.nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}

.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-dark .navbar-brand {
  color: #fff;
}

.navbar-dark .navbar-brand:focus,
.navbar-dark .navbar-brand:hover {
  color: #fff;
}

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}

.navbar-dark .navbar-nav .nav-link:focus,
.navbar-dark .navbar-nav .nav-link:hover {
  color: rgba(255, 255, 255, 0.75);
}

.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}

.navbar-dark .navbar-nav .show>.nav-link,
.navbar-dark .navbar-nav .active>.nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}

.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}

/*
 * 2. BUTTONS
 */
.btn {
  font-weight: 400;
  border: 1px solid transparent;
  padding: 0.6rem 16px 0.45rem;
  font-size: 1rem;
  line-height: 1.39rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn:focus,
.btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(219, 101, 116, 0.25);
}

.btn.disabled,
.btn:disabled {
  opacity: 0.65;
}

.btn:not([disabled]):not(.disabled):active,
.btn:not([disabled]):not(.disabled).active {
  background-image: none;
}

.btn-primary {
  color: color-yiq(#2186AD);
  background-color: #2186AD;
  border-color: #2186AD;
}

.btn-primary:hover {
  color: color-yiq(#139DD3);
  background-color: #139DD3;
  border-color: #139DD3
}

.btn-primary:focus,
.btn-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(21, 113, 146, 0.2);
  background-color: #0277A4;
  border-color: #0277A4;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: color-yiq(#2186AD);
  background-color: #444951;
  border-color: #444951;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
  color: color-yiq(#199DD0);
  background-color: #139DD3;
  border-color: #199DD0;
}

.btn-primary:not(:disabled):not(.disabled):active:focus,
.btn-primary:not(:disabled):not(.disabled).active:focus,
.show>.btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(21, 113, 146, 0.2);
}

.btn-secondary {
  color: color-yiq(#868e96);
  background-color: #868e96;
  border-color: #868e96;
}

.btn-secondary:hover {
  color: color-yiq(#727b84);
  background-color: #727b84;
  border-color: #6c757d;
}

.btn-secondary:focus,
.btn-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(134, 142, 150, 0.5);
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  color: color-yiq(#868e96);
  background-color: #868e96;
  border-color: #868e96;
}

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show>.btn-secondary.dropdown-toggle {
  color: color-yiq(#6c757d);
  background-color: #6c757d;
  border-color: #666e76;
}

.btn-secondary:not(:disabled):not(.disabled):active:focus,
.btn-secondary:not(:disabled):not(.disabled).active:focus,
.show>.btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(134, 142, 150, 0.5);
}

.btn-success {
  color: color-yiq(#28a745);
  background-color: #28a745;
  border-color: #28a745;
}

.btn-success:hover {
  color: color-yiq(#218838);
  background-color: #218838;
  border-color: #1e7e34;
}

.btn-success:focus,
.btn-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.btn-success.disabled,
.btn-success:disabled {
  color: color-yiq(#28a745);
  background-color: #28a745;
  border-color: #28a745;
}

.btn-success:not(:disabled):not(.disabled):active,
.btn-success:not(:disabled):not(.disabled).active,
.show>.btn-success.dropdown-toggle {
  color: color-yiq(#1e7e34);
  background-color: #1e7e34;
  border-color: #1c7430;
}

.btn-success:not(:disabled):not(.disabled):active:focus,
.btn-success:not(:disabled):not(.disabled).active:focus,
.show>.btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.btn-info {
  color: color-yiq(#17a2b8);
  background-color: #17a2b8;
  border-color: #17a2b8;
}

.btn-info:hover {
  color: color-yiq(#138496);
  background-color: #138496;
  border-color: #117a8b;
}

.btn-info:focus,
.btn-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.btn-info.disabled,
.btn-info:disabled {
  color: color-yiq(#17a2b8);
  background-color: #17a2b8;
  border-color: #17a2b8;
}

.btn-info:not(:disabled):not(.disabled):active,
.btn-info:not(:disabled):not(.disabled).active,
.show>.btn-info.dropdown-toggle {
  color: color-yiq(#117a8b);
  background-color: #117a8b;
  border-color: #10707f;
}

.btn-info:not(:disabled):not(.disabled):active:focus,
.btn-info:not(:disabled):not(.disabled).active:focus,
.show>.btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.btn-warning {
  color: color-yiq(#ffc107);
  background-color: #ffc107;
  border-color: #ffc107;
}

.btn-warning:hover {
  color: color-yiq(#e0a800);
  background-color: #e0a800;
  border-color: #d39e00;
}

.btn-warning:focus,
.btn-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-warning.disabled,
.btn-warning:disabled {
  color: color-yiq(#ffc107);
  background-color: #ffc107;
  border-color: #ffc107;
}

.btn-warning:not(:disabled):not(.disabled):active,
.btn-warning:not(:disabled):not(.disabled).active,
.show>.btn-warning.dropdown-toggle {
  color: color-yiq(#d39e00);
  background-color: #d39e00;
  border-color: #c69500;
}

.btn-warning:not(:disabled):not(.disabled):active:focus,
.btn-warning:not(:disabled):not(.disabled).active:focus,
.show>.btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-danger {
  color: color-yiq(#bb414d);
  background-color: #bb414d;
  border-color: #bb414d;
  margin-left: 10px;
}

.btn-danger:hover {
  color: color-yiq(#9f3741);
  background-color: #9f3741;
  border-color: #95343d;
}

.btn-danger:focus,
.btn-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(187, 65, 77, 0.5);
}

.btn-danger.disabled,
.btn-danger:disabled {
  color: color-yiq(#bb414d);
  background-color: #bb414d;
  border-color: #bb414d;
}

.btn-danger:not(:disabled):not(.disabled):active,
.btn-danger:not(:disabled):not(.disabled).active,
.show>.btn-danger.dropdown-toggle {
  color: color-yiq(#95343d);
  background-color: #95343d;
  border-color: #8c313a;
}

.btn-danger:not(:disabled):not(.disabled):active:focus,
.btn-danger:not(:disabled):not(.disabled).active:focus,
.show>.btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(187, 65, 77, 0.5);
}

.btn-light {
  color: color-yiq(#e9ecef);
  background-color: #e9ecef;
  border-color: #e9ecef;
}

.btn-light:hover {
  color: color-yiq(#d3d9df);
  background-color: #d3d9df;
  border-color: #cbd3da;
}

.btn-light:focus,
.btn-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 236, 239, 0.5);
}

.btn-light.disabled,
.btn-light:disabled {
  color: color-yiq(#e9ecef);
  background-color: #e9ecef;
  border-color: #e9ecef;
}

.btn-light:not(:disabled):not(.disabled):active,
.btn-light:not(:disabled):not(.disabled).active,
.show>.btn-light.dropdown-toggle {
  color: color-yiq(#cbd3da);
  background-color: #cbd3da;
  border-color: #c4ccd4;
}

.btn-light:not(:disabled):not(.disabled):active:focus,
.btn-light:not(:disabled):not(.disabled).active:focus,
.show>.btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 236, 239, 0.5);
}

.btn-dark {
  color: color-yiq(#212529);
  background-color: #212529;
  border-color: #212529;
}

.btn-dark:hover {
  color: color-yiq(#101214);
  background-color: #101214;
  border-color: #0a0c0d;
}

.btn-dark:focus,
.btn-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);
}

.btn-dark.disabled,
.btn-dark:disabled {
  color: color-yiq(#212529);
  background-color: #212529;
  border-color: #212529;
}

.btn-dark:not(:disabled):not(.disabled):active,
.btn-dark:not(:disabled):not(.disabled).active,
.show>.btn-dark.dropdown-toggle {
  color: color-yiq(#0a0c0d);
  background-color: #0a0c0d;
  border-color: #050506;
}

.btn-dark:not(:disabled):not(.disabled):active:focus,
.btn-dark:not(:disabled):not(.disabled).active:focus,
.show>.btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);
}

.btn.btn-outline-primary {
  color: #000000;
  background-color: transparent;
  background-image: none;
  border:1px solid #000000;
}

.btn.btn-outline-primary:hover {
  color:#f97315;
  background-color:transparent;
  border-color: #f97315;
}

.btn-outline-primary:focus,
.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: #2186AD;
  background-color: transparent;
}

.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show>.btn-outline-primary.dropdown-toggle {
  color: color-yiq(#2186AD);
  background-color: #2186AD;
  border-color: #2186AD;
}

.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.2);
}

.btn-outline-secondary {
  color: #868e96;
  background-color: transparent;
  background-image: none;
  border-color: #868e96;
}

.btn-outline-secondary:hover {
  color: #fff;
  background-color: #868e96;
  border-color: #868e96;
}

.btn-outline-secondary:focus,
.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(134, 142, 150, 0.5);
}

.btn-outline-secondary.disabled,
.btn-outline-secondary:disabled {
  color: #868e96;
  background-color: transparent;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show>.btn-outline-secondary.dropdown-toggle {
  color: color-yiq(#868e96);
  background-color: #868e96;
  border-color: #868e96;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(134, 142, 150, 0.5);
}

.btn-outline-success {
  color: #28a745;
  background-color: transparent;
  background-image: none;
  border-color: #28a745;
}

.btn-outline-success:hover {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.btn-outline-success:focus,
.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.btn-outline-success.disabled,
.btn-outline-success:disabled {
  color: #28a745;
  background-color: transparent;
}

.btn-outline-success:not(:disabled):not(.disabled):active,
.btn-outline-success:not(:disabled):not(.disabled).active,
.show>.btn-outline-success.dropdown-toggle {
  color: color-yiq(#28a745);
  background-color: #28a745;
  border-color: #28a745;
}

.btn-outline-success:not(:disabled):not(.disabled):active:focus,
.btn-outline-success:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.btn-outline-info {
  color: #17a2b8;
  background-color: transparent;
  background-image: none;
  border-color: #17a2b8;
}

.btn-outline-info:hover {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}

.btn-outline-info:focus,
.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.btn-outline-info.disabled,
.btn-outline-info:disabled {
  color: #17a2b8;
  background-color: transparent;
}

.btn-outline-info:not(:disabled):not(.disabled):active,
.btn-outline-info:not(:disabled):not(.disabled).active,
.show>.btn-outline-info.dropdown-toggle {
  color: color-yiq(#17a2b8);
  background-color: #17a2b8;
  border-color: #17a2b8;
}

.btn-outline-info:not(:disabled):not(.disabled):active:focus,
.btn-outline-info:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.btn-outline-warning {
  color: #ffc107;
  background-color: transparent;
  background-image: none;
  border-color: #ffc107;
}

.btn-outline-warning:hover {
  color: #fff;
  background-color: #ffc107;
  border-color: #ffc107;
}

.btn-outline-warning:focus,
.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
  color: #ffc107;
  background-color: transparent;
}

.btn-outline-warning:not(:disabled):not(.disabled):active,
.btn-outline-warning:not(:disabled):not(.disabled).active,
.show>.btn-outline-warning.dropdown-toggle {
  color: color-yiq(#ffc107);
  background-color: #ffc107;
  border-color: #ffc107;
}

.btn-outline-warning:not(:disabled):not(.disabled):active:focus,
.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-outline-danger {
  color: #bb414d;
  background-color: transparent;
  background-image: none;
  border-color: #bb414d;
}

.btn-outline-danger:hover {
  color: #fff;
  background-color: #bb414d;
  border-color: #bb414d;
}

.btn-outline-danger:focus,
.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(187, 65, 77, 0.5);
}

.btn-outline-danger.disabled,
.btn-outline-danger:disabled {
  color: #bb414d;
  background-color: transparent;
}

.btn-outline-danger:not(:disabled):not(.disabled):active,
.btn-outline-danger:not(:disabled):not(.disabled).active,
.show>.btn-outline-danger.dropdown-toggle {
  color: color-yiq(#bb414d);
  background-color: #bb414d;
  border-color: #bb414d;
}

.btn-outline-danger:not(:disabled):not(.disabled):active:focus,
.btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(187, 65, 77, 0.5);
}

.btn-outline-light {
  color: #e9ecef;
  background-color: transparent;
  background-image: none;
  border-color: #e9ecef;
}

.btn-outline-light:hover {
  color: #fff;
  background-color: #e9ecef;
  border-color: #e9ecef;
}

.btn-outline-light:focus,
.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 236, 239, 0.5);
}

.btn-outline-light.disabled,
.btn-outline-light:disabled {
  color: #e9ecef;
  background-color: transparent;
}

.btn-outline-light:not(:disabled):not(.disabled):active,
.btn-outline-light:not(:disabled):not(.disabled).active,
.show>.btn-outline-light.dropdown-toggle {
  color: color-yiq(#e9ecef);
  background-color: #e9ecef;
  border-color: #e9ecef;
}

.btn-outline-light:not(:disabled):not(.disabled):active:focus,
.btn-outline-light:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 236, 239, 0.5);
}

.btn-outline-dark {
  color: #212529;
  background-color: transparent;
  background-image: none;
  border-color: #212529;
}

.btn-outline-dark:hover {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}

.btn-outline-dark:focus,
.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);
}

.btn-outline-dark.disabled,
.btn-outline-dark:disabled {
  color: #212529;
  background-color: transparent;
}

.btn-outline-dark:not(:disabled):not(.disabled):active,
.btn-outline-dark:not(:disabled):not(.disabled).active,
.show>.btn-outline-dark.dropdown-toggle {
  color: color-yiq(#212529);
  background-color: #212529;
  border-color: #212529;
}

.btn-outline-dark:not(:disabled):not(.disabled):active:focus,
.btn-outline-dark:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);
}

.btn-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

/*
 * 3. TYPE
 */
body {
  /* font-family: "Muli", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #8a8d93;
  background-color: #fff; */
}

body {
  font-family: 'helvetica', sans-serif;
}

a {
  color: #000;
  text-decoration: none;
}

a:focus,
a:hover {
  color: #c52e41;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 700;
  line-height: 1.2;
  color: inherit;
}

h1,
.h1 {
  font-size: 2.5rem;
}

h2,
.h2 {
  font-size: 1.7rem;
}

h3,
.h3 {
  font-size: 1.5rem;
}

h4,
.h4 {
  font-size: 1.3rem;
}

h5,
.h5 {
  font-size: 1.1rem;
  position: inherit !important;
}

h6,
.h6 {
  font-size: 1rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

hr {
  border-top: 1px solid #6a6c70;
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.blockquote {
  padding: 0.5rem 1rem;
  margin-bottom: 2rem;
  font-size: 1.25rem;
  border-left: 5px solid #2186AD;
}

.blockquote-footer {
  color: #868e96;
}

.blockquote-footer::before {
  content: "\\2014 \\00A0";
}

.text-primary {
  color: #2186AD !important;
}

a.text-primary:focus,
a.text-primary:hover {
  color: #d13c4f !important;
}

/*
 * 4. PAGINATION
 */
.pagination .page-item:first-child .page-link {
  border-radius: 3px;
}

.pagination .page-item:last-child .page-link {
  border-radius: 3px;
}

.pagination .page-item.active .page-link {
  color: #fff;
  background-color: #0CA751;
}

.pagination .page-item.disabled .page-link {
  color: rgba(0, 0, 0, 0.45);
  background-color: rgba(0, 0, 0, 0.03);
  border: none;
}

.pagination .page-link {
  padding: 4px 4px;
  margin-left: 0px;
  flex: auto;
  color: rgba(0, 0, 0, 0.8);
  background-color: rgba(0, 0, 0, 0.07);
  border: none;
  border-radius: 3px;
  font-size: 14px;
  min-width: 33px;
  height: 29px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination  .page-link:hover {
  z-index: 2;
  color: #139B0E;
  background-color:rgba(59, 213, 69, 0.10);
}

.pagination .page-link:focus {
  z-index: 2;
  outline: 0;
  box-shadow: none;
  text-decoration: none;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}

.pagination .page-link .visually-hidden{
  display: none;
}

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

/*
* 5. UTILITIES
*/
.bg-primary {
  background-color: #2186AD !important;
}

a.bg-primary:focus,
a.bg-primary:hover {
  background-color: #d13c4f !important;
}

.bg-secondary {
  background-color: #868e96 !important;
}

a.bg-secondary:focus,
a.bg-secondary:hover {
  background-color: #6c757d !important;
}

.bg-success {
  background-color: #20A701 !important;
}

a.bg-success:focus,
a.bg-success:hover {
  background-color: #27C603 !important;
}

.bg-info {
  background-color: #08A9C6 !important;
}

a.bg-info:focus,
a.bg-info:hover {
  background-color: #117a8b !important;
}

.bg-warning {
  background-color: #ffc107 !important;
}

a.bg-warning:focus,
a.bg-warning:hover {
  background-color: #d39e00 !important;
}

.bg-danger {
  background-color: #E01A1A !important;
}

a.bg-danger:focus,
a.bg-danger:hover {
  background-color: #FC1212 !important;
}

.bg-light {
  background-color: #e9ecef !important;
}

a.bg-light:focus,
a.bg-light:hover {
  background-color: #cbd3da !important;
}

.bg-dark {
  background-color: #212529 !important;
}

a.bg-dark:focus,
a.bg-dark:hover {
  background-color: #0a0c0d !important;
}

.border-primary {
  border-color: #2186AD !important;
}

.border-secondary {
  border-color: #868e96 !important;
}

.border-success {
  border-color: #28a745 !important;
}

.border-info {
  border-color: #17a2b8 !important;
}

.border-warning {
  border-color: #ffc107 !important;
}

.border-danger {
  border-color: #bb414d !important;
}

.border-light {
  border-color: #e9ecef !important;
}

.border-dark {
  border-color: #212529 !important;
}

.text-primary {
  color: #2186AD !important;
}

a.text-primary:focus,
a.text-primary:hover {
  color: #d13c4f !important;
}

.text-secondary {
  color: #868e96 !important;
}

a.text-secondary:focus,
a.text-secondary:hover {
  color: #6c757d !important;
}

.text-success {
  color: #28a745 !important;
}

a.text-success:focus,
a.text-success:hover {
  color: #1e7e34 !important;
}

.text-info {
  color: #17a2b8 !important;
}

a.text-info:focus,
a.text-info:hover {
  color: #117a8b !important;
}

.text-warning {
  color: #ffc107 !important;
}

a.text-warning:focus,
a.text-warning:hover {
  color: #d39e00 !important;
}

.text-danger {
  color: #bb414d !important;
}

a.text-danger:focus,
a.text-danger:hover {
  color: #95343d !important;
}

.text-light {
  color: #e9ecef !important;
}

a.text-light:focus,
a.text-light:hover {
  color: #cbd3da !important;
}

.text-dark {
  color: #212529 !important;
}

a.text-dark:focus,
a.text-dark:hover {
  color: #0a0c0d !important;
}

.badge-primary {
  color: color-yiq(#2186AD);
  background-color: #2186AD;
}

.badge-primary[href]:focus,
.badge-primary[href]:hover {
  color: color-yiq(#2186AD);
  text-decoration: none;
  background-color: #d13c4f;
}

.badge-secondary {
  color: color-yiq(#868e96);
  background-color: #868e96;
}

.badge-secondary[href]:focus,
.badge-secondary[href]:hover {
  color: color-yiq(#868e96);
  text-decoration: none;
  background-color: #6c757d;
}

.badge-success {
  color: color-yiq(#28a745);
  background-color: #28a745;
}

.badge-success[href]:focus,
.badge-success[href]:hover {
  color: color-yiq(#28a745);
  text-decoration: none;
  background-color: #1e7e34;
}

.badge-info {
  color: color-yiq(#17a2b8);
  background-color: #17a2b8;
}

.badge-info[href]:focus,
.badge-info[href]:hover {
  color: color-yiq(#17a2b8);
  text-decoration: none;
  background-color: #117a8b;
}

.badge-warning {
  color: color-yiq(#ffc107);
  background-color: #ffc107;
}

.badge-warning[href]:focus,
.badge-warning[href]:hover {
  color: color-yiq(#ffc107);
  text-decoration: none;
  background-color: #d39e00;
}

.badge-danger {
  color: color-yiq(#bb414d);
  background-color: #bb414d;
}

.badge-danger[href]:focus,
.badge-danger[href]:hover {
  color: color-yiq(#bb414d);
  text-decoration: none;
  background-color: #95343d;
}

.badge-light {
  color: color-yiq(#e9ecef);
  background-color: #e9ecef;
}

.badge-light[href]:focus,
.badge-light[href]:hover {
  color: color-yiq(#e9ecef);
  text-decoration: none;
  background-color: #cbd3da;
}

.badge-dark {
  color: color-yiq(#212529);
  background-color: #212529;
}

.badge-dark[href]:focus,
.badge-dark[href]:hover {
  color: color-yiq(#212529);
  text-decoration: none;
  background-color: #0a0c0d;
}

/*
* 6.CODE
*/
code {
  padding: 0.2rem 0.4rem;
  font-size: 90%;
  color: #2186AD;
  background-color: #22252a;
  border-radius: 0.25rem;
}

a>code {
  padding: 0;
  color: inherit;
  background-color: inherit;
}

pre code {
  background: none;
}

/*
* 7. NAV
*/
.nav-link {
  padding: 1rem 1rem;
}

.nav-link.disabled {
  color: #868e96;
}

.nav-tabs .nav-item {
  margin-bottom: -1px;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  border-color: #34373d;
}

.nav-tabs .nav-link.disabled {
  color: #868e96;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #8a8d93;
  background-color: #22252a;
  border-color: #34373d;
}

.nav-tabs .dropdown-menu {
  margin-top: -1px;
}

.nav-pills .nav-link {
  border-radius: 0.25rem;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #fff;
  background-color: #2186AD;
}

/*
* 8. CARD
*/
.card {
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  box-shadow: none;
}

.card>.list-group:first-child .list-group-item:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.card>.list-group:last-child .list-group-item:last-child {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.card-body {
  padding: 1.25rem 20px;
}

.card-title {
  margin-bottom: 0;
}

.card-subtitle {
  margin-top: 0;
}

.card-link+.card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 18px 20px;
  background: transparent;
  border-bottom: 1px solid rgb(212 212 212);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-header:first-child {
  border-radius: 0 0 0 0;
}

.card-header-transparent {
  background-color: rgba(0, 0, 0, 0.3);
  border-bottom: none;
}

.card-header .cardTitle+.cardTitle {
  margin-left: 60px;
}

.card-header .cardTitle h5 {
  font-weight: 500;
  font-size: 16px;
}

.card-header .cardTitle p {
  font-weight: 400;
  font-size: 15px;
  color: #717171;
  line-height: 1.4;
  margin: 5px 0 0 0;
}

.card-header .cardTitle .label {
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.43);
}

.card-footer {
  padding: 16px 20px;
  background-color: transparent;
  border-top: 1px solid #34373d;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
}

.card-footer:last-child {
  border-radius: 0 0 0 0;
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  padding: 1.25rem;
}

.card-img-overlay-opacity {
  background: rgba(0, 0, 0, 0.2);
}

.card-img {
  border-radius: 0;
}

.card-img-top {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.card-img-bottom {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.card-deck .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-deck {
    margin-right: -15px;
    margin-left: -15px;
  }

  .card-deck .card {
    margin-right: 15px;
    margin-left: 15px;
  }
}

.card .list-group-item {
  background: #2d3035;
  border-color: #34373d;
}

.blue-color {
  color: #007bff !important;
}

.blue-color:hover {
  text-decoration: underline;
}

.table td,
.table th {
  border-color: #C9C7C7;
  padding: 1rem;
  vertical-align: middle;
}

td .profileWrap .cont p {
  max-width: 160px;
  word-wrap: break-word;
}

.tableFilterWrap button.btn.btn-primary.mn-w-148.me-3 {
  padding: 8px 14px;
}

@media (max-width: 599px) {
  nav#sidebar {
    top: 62px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/default.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EAGnB,0EAA0E;AAC5E;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;CAIC;AACD;;;;;;;;GAQG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;gCAC8B;EAC9B,cAAc;AAChB;;AAEA;EACE;gCAC8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,2BAA2B;;;AAG3B;EAEE,wBAAwB;AAC1B;;AAEA,2DAA2D;AAC3D;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,cAAc;IACd,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,cAAc;EAChB;;;AAGF;;AAEA;;;;CAIC;AACD;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,+BAA+B;EAC/B,oBAAoB;EACpB,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;;AAEtB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EAErB,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;;EAGE,0CAA0C;AAC5C;;;AAGA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;;AAGA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;GAEG,eAAe;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;;AAGA;;EAEE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;IACI,iCAAiC;IACjC,cAAc;IACd,gBAAgB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAEhB,gCAAgC;EAChC,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4DAA4D;;AAE5D;EACE;IACE,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;;EAGA;;KAEG;;AAEL;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,OAAO;EACT;;;;EAIA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;;;EAIA;IACE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;;EAGA,gBAAgB;EAChB;IACE,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IAEE,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE;IACE,aAAa;EACf;AACF;;;AAGA,eAAe;AACf;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;;;CAIC;AACD,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAET,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE;IACE,YAAY;EACd;AACF;;AAEA;;;;CAIC;AACD,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;;;AAIA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;;AAGA;EACE,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;EACX,eAAe;AACjB;;;;AAIA;;;;CAIC;AACD;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;CAIC;AACD;EACE,gCAAgC;EAChC,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;EACrB,aAAa;EAEb,kDAAkD;AACpD;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,8FAA6N;EAC7N,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAGhB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EAEV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAGE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;;EAGE,0BAA0B;EAC1B,yBAAyB;EAGzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EAErB,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EAEnB,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,UAAU;EAEV,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAElB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EAEZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;;;EASE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;CAIC;AACD;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,iBAAiB;EAEjB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;;CAIC;AACD;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;;;;CAIC;AACD;EACE,eAAe;EACf,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;8CAE8C;AAC9C;;EAEE;AACF;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yDAAqQ;AACvQ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,yDAA2Q;AAC7Q;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE;AACF;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EAMtB;gEAC8D;AAIhE;;AAEA;;EAEE,UAAU;EAEV,kDAAkD;AACpD;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB;AACF;;AAEA;;EAGE,gDAAgD;EAChD,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,iDAAiD;AACnD;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,+CAA+C;AACjD;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,gDAAgD;AAClD;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,+CAA+C;AACjD;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,+CAA+C;AACjD;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,iDAAiD;AACnD;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,8CAA8C;AAChD;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;;EAGE,8CAA8C;AAChD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,+CAA+C;AACjD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,gDAAgD;AAClD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,+CAA+C;AACjD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,+CAA+C;AACjD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAGE,8CAA8C;AAChD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAIE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE;AACF;EACE;;;;;2BAKyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;EAYE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE;AACF;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,UAAU;EAEV,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;;CAEC;AACD;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;CAEC;AACD;EACE,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;CAEC;AACD;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;CAEC;AACD;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,SAAS;EACX;AACF","sourcesContent":["\n*/ body {\n  position: relative;\n}\n\nsection {\n  padding: 0 0.6rem;\n}\n\n.dashtext-1 {\n  color: #864dd9 !important;\n}\n\n.dashtext-2 {\n  color: #cf53f9 !important;\n}\n\n.dashtext-3 {\n  color: #e95f71 !important;\n}\n\n.dashtext-4 {\n  color: #7127ac !important;\n}\n\n.dashbg-1 {\n  background: #864dd9;\n}\n\n.dashbg-2 {\n  background: #cf53f9;\n}\n\n.dashbg-3 {\n  background: #e95f71;\n}\n\n.dashbg-4 {\n  background: #7127ac;\n}\n\n.text-bold {\n  font-weight: 700;\n}\n\n.text-small {\n  font-size: 0.8rem;\n}\n\n.text-gray-light {\n  color: #dee2e6;\n}\n\n.text-gray {\n  color: #8a8d93;\n}\n\n.text-gray-dark {\n  color: #6a6c70;\n}\n\n.text-black {\n  color: #000;\n}\n\n.text-uppercase {\n  letter-spacing: 0.1em;\n}\n\n.lh-2 {\n  line-height: 2;\n}\n\n.list-group-item {\n  border-right: 0;\n  border-left: 0;\n}\n\n.list-group-item:first-child,\n.list-group-item:last-child {\n  border-radius: 0;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.tile-link {\n  position: absolute;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  z-index: 30;\n}\n\np {\n  line-height: 1.7;\n}\n\nbutton {\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n}\n\ni,\nspan,\nstrong {\n  display: inline-block;\n}\n\ninput {\n  outline: none;\n}\n\npre {\n  color: #8a8d93;\n}\n\n.dropdown-divider {\n  border-top-color: #6a6c70;\n}\n\n.no-padding {\n  padding: 0 !important;\n}\n\n.no-padding-top {\n  padding-top: 0 !important;\n}\n\n.no-padding-bottom {\n  padding-bottom: 0 !important;\n}\n\n.no-margin {\n  margin: 0 !important;\n}\n\n.no-margin-top {\n  margin-top: 0 !important;\n}\n\n.no-margin-bottom {\n  margin-bottom: 0 !important;\n}\n\n.padding-top-sm {\n  padding-top: 30px !important;\n}\n\n.padding-bottom-sm {\n  padding-bottom: 30px !important;\n}\n\n.margin-top-sm {\n  margin-top: 30px !important;\n}\n\n.margin-bottom-sm {\n  margin-bottom: 30px !important;\n}\n\n.breadcrumb {\n  background: none;\n  padding: 20px 20px;\n  margin-bottom: 0;\n  color: #8a8d93;\n}\n\n.breadcrumb a {\n  color: #2186AD;\n  text-decoration: none !important;\n}\n\n.breadcrumb li.active {\n  color: #585a5f;\n}\n\n.breadcrumb-item+.breadcrumb-item::before {\n  color: #585a5f;\n}\n\n.block {\n  padding: 20px;\n  background: #fff;\n  color: #000000;\n  border: 1px solid #E8E8E8;\n  border-radius: 4px;\n  margin-bottom: 30px;\n}\n\n.card {\n  margin-bottom: 30px;\n  -webkit-box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1),\n    -1px 0 2px rgba(0, 0, 0, 0.05);\n  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1), -1px 0 2px rgba(0, 0, 0, 0.05);\n}\n\n.card-header h1,\n.card-header h2,\n.card-header h3,\n.card-header h4,\n.card-header h5,\n.card-header h6 {\n  margin-bottom: 0;\n}\n\n.page-content {\n  position: relative;\n  /* background: #ECEEF2; */\n  min-height: calc(100vh - 73px);\n  width: calc(100% - 222px);\n  padding: 0 28px;\n  padding-bottom: 70px;\n}\n\n.page-content.active {\n  width: 100%;\n}\n\n.page-header {\n  padding: 20px 15px;\n  background: rgb(84, 178, 203);\n  color: #fff;\n  margin-bottom: 30px;\n}\n\n.footer {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n\n.footer .footer__block {\n  min-height: 70px;\n}\n\n.dropdown-menu {\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);\n  font-size: 1rem;\n  min-width: 200px;\n  background: #fff;\n  border-radius: 2.5px;\n  padding: 0;\n  margin-top: 8px;\n  border: 1px solid #f4f4f4;\n}\n\n.dropdown-menu a {\n  color: inherit;\n}\n\n.dropdown-toggle {\n  background: none;\n  outline: none;\n  border-radius: 0;\n}\n\n.dropdown-toggle span.caret {\n  color: #555;\n}\n\n.dropdown-menu a {\n  padding: 10px 15px;\n  font-size: 0.9rem;\n  text-transform: none;\n}\n\n.dropdown-submenu {\n  position: relative;\n}\n\n.dropdown-submenu>.dropdown-menu {\n  top: 0;\n  left: 100%;\n  margin-top: -2px;\n  font-size: 1rem;\n}\n\n.megamenu {\n  width: 100%;\n  padding: 40px 30px;\n  margin-top: 0 !important;\n  z-index: 1100 !important;\n}\n\n.megamenu strong {\n  margin-bottom: 10px;\n  display: block;\n}\n\n.megamenu ul {\n  padding: 0;\n  margin: 0;\n}\n\n.megamenu ul a {\n  padding: 5px 0 !important;\n  text-decoration: none;\n  color: #555;\n  font-size: 0.9em !important;\n}\n\n.megamenu ul a:hover {\n  background: none;\n  color: #2186AD !important;\n}\n\n.megamenu .megamenu-buttons {\n  color: #fff;\n  margin-top: 40px;\n}\n\n.megamenu .megamenu-buttons .megamenu-button-link {\n  padding: 20px !important;\n  text-decoration: none;\n  font-weight: 300;\n}\n\n.megamenu .megamenu-buttons .megamenu-button-link.dashbg-1:hover {\n  background: #7838d5 !important;\n}\n\n.megamenu .megamenu-buttons .megamenu-button-link.dashbg-2:hover {\n  background: #c83af8 !important;\n}\n\n.megamenu .megamenu-buttons .megamenu-button-link.dashbg-3:hover {\n  background: #e6495d !important;\n}\n\n.megamenu .megamenu-buttons .megamenu-button-link.dashbg-4:hover {\n  background: #632297 !important;\n}\n\n.block .title {\n  margin-bottom: 20px;\n}\n\n.block .title strong:first-child {\n  font-size: 1.25rem;\n  color: #a5a7ab;\n}\n\n.block .title span:first-child {\n  font-weight: 300;\n  font-size: 0.95rem;\n}\n\n/*\n* ==========================================================\n*     NAVBAR\n* ==========================================================\n*/\n/* nav.navbar {\n  background:#131517;\n  color: #fff;\n  padding: 0;\n  border-bottom: none;\n  box-shadow:none;\n  z-index: 10;\n  border-bottom: 1px solid #2D3034;\n} */\n\nnav.navbar .sidebar-toggle {\n  width: 36px;\n  height: 36px;\n  text-align: center;\n  border-radius: 0%;\n  background: none;\n  border: none;\n  outline: none;\n  position: relative;\n  margin: 0 10px 0 0px;\n  padding: 0;\n  border: none;\n}\n\nnav.navbar .sidebar-toggle .toggle-icon {\n  width: 22px;\n  position: relative;\n  display: block;\n  height: 2px;\n  background: #707070;\n  border-radius: 4px;\n}\n\nnav.navbar .sidebar-toggle .toggle-icon:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: -7px;\n  height: 2px;\n  background: #707070;\n  border-radius: 4px;\n  transition: 0.25s ease-out;\n}\n\nnav.navbar .sidebar-toggle .toggle-icon:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 10px;\n  top: 7px;\n  height: 2px;\n  background: #707070;\n  border-radius: 4px;\n  transition: 0.25s ease-out;\n}\n\n.sideMenuFixed nav.navbar .sidebar-toggle .toggle-icon:before {\n  transform: rotate(-35deg);\n  left: -1px;\n  width: 15px;\n  right: auto;\n  top: -4.3px;\n}\n\n.sideMenuFixed nav.navbar .sidebar-toggle .toggle-icon:after {\n  transform: rotate(35deg);\n  left: -1px;\n  width: 15px;\n  right: auto;\n  top: 4.4px;\n}\n\nnav.navbar a {\n  color: inherit;\n}\n\nnav.navbar .brand-text {\n  display: none;\n  font-weight: 700;\n}\n\nnav.navbar .brand-text.visible {\n  display: block;\n}\n\nnav.navbar a.nav-link {\n  padding: 0.5rem 0.3rem;\n  position: relative;\n}\n\nnav.navbar .nav-link .badge {\n  width: 10px;\n  height: 10px;\n  text-align: center;\n  border-radius: 50%;\n  padding: 0;\n  font-size: 0.7rem;\n  position: absolute;\n  top: 1px;\n  right: 12px;\n  background: #DD0A0A;\n}\n\nnav.navbar .messages-toggle,\nnav.navbar .tasks-toggle {\n  margin-right: 15px;\n}\n\nnav.navbar .menu-large {\n  position: static !important;\n}\n\nnav.navbar .search-panel {\n  display: none;\n}\n\nnav.navbar .search-inner {\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(45, 48, 53, 0.95);\n  z-index: 9;\n}\n\nnav.navbar .search-inner .close-btn {\n  position: absolute;\n  top: 20px;\n  right: 40px;\n  font-size: 1.1em;\n  font-weight: 400;\n  cursor: pointer;\n}\n\nnav.navbar .search-inner form {\n  width: 100%;\n  max-width: 800px;\n  padding: 20px;\n}\n\nnav.navbar .search-inner .form-group {\n  position: relative;\n}\n\nnav.navbar .search-inner .submit {\n  background: none;\n  font-size: 2.3rem;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  color: #8a8d93;\n  border: none;\n  font-weight: 700 !important;\n}\n\nnav.navbar .search-inner input {\n  background: none;\n  width: 100%;\n  font-size: 2rem;\n  border: none;\n  border-bottom: 1px solid #444951;\n  color: #8a8d93;\n}\n\nnav.navbar .search-inner input::-moz-placeholder {\n  color: #585a5f;\n}\n\nnav.navbar .search-inner input::-webkit-input-placeholder {\n  /* font-family: \"Muli\", sans-serif;\n  font-weight: 300 !important; */\n  color: #535353;\n}\n\nnav.navbar .search-inner input:-ms-input-placeholder {\n  /* font-family: \"Muli\", sans-serif; \n  font-weight: 300 !important; */\n  color: #535353;\n}\n\nnav.navbar .dropdown-menu {\n  min-width: 300px;\n  left: auto;\n  right: 0;\n  inset-inline-start: auto !important;\n}\n\nnav.navbar .dropdown-item {\n  padding: 1rem;\n  border-bottom: 1px solid rgba(112, 112, 112, 0.16);\n}\n\nnav.navbar .dropdown-item:hover {\n  background: #EDEDED;\n  color: #000;\n}\n\nnav.navbar .dropdown-item:last-of-type {\n  border-bottom: none;\n}\n\nnav.navbar .dropdown-item.message {\n  color: #464646;\n  text-decoration: none;\n}\n\nnav.navbar .dropdown-item.message li:last-of-type a {\n  border-bottom: none;\n}\n\nnav.navbar .dropdown-item.message .profile {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  margin-right: 15px;\n  position: relative;\n}\n\nnav.navbar .dropdown-item.message .profile img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n}\n\nnav.navbar .dropdown-item.message .profile .status {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  position: absolute;\n  top: 2px;\n  right: 2px;\n}\n\nnav.navbar .dropdown-item.message .profile .status.online {\n  background: #28a745;\n}\n\nnav.navbar .dropdown-item.message .profile .status.away {\n  background: #ffc107;\n}\n\nnav.navbar .dropdown-item.message .profile .status.busy {\n  background: #dc3545;\n}\n\nnav.navbar .dropdown-item.message .profile .status.offline {\n  background: #999;\n}\n\nnav.navbar .dropdown-item.message .content strong {\n  font-size: 1rem;\n}\n\nnav.navbar .dropdown-item.message .content span {\n  font-weight: 300;\n  font-size: 0.85rem;\n}\n\nnav.navbar .dropdown-item.message .content .date {\n  color: #70737a;\n}\n\nnav.navbar .tasks-list strong {\n  font-size: 1rem;\n}\n\nnav.navbar .tasks-list span {\n  font-size: 0.95rem;\n}\n\nnav.navbar .tasks-list .progress {\n  height: 2px;\n  margin-top: 10px;\n  background: #444951;\n}\n\nnav.navbar a.language span {\n  margin-left: 0.2rem;\n  vertical-align: middle;\n}\n\n/* Navbar dropdown effect */\n\n\nnav.navbar .dropdown .dropdown-menu.active {\n  -webkit-transform: translateY(0);\n  transform: translateY(0);\n}\n\n/* Navbar Media Query ----------------------------------- */\n@media (max-width: 1331px) {\n  nav.navbar .right-menu {\n    margin-bottom: -3px;\n  }\n\n  nav.navbar .navbar-brand {\n    margin-right: 5px;\n  }\n\n  nav.navbar .search-inner form input {\n    font-size: 1.25rem !important;\n  }\n\n  nav.navbar .search-inner form button.submit {\n    position: absolute;\n    font-size: 2rem;\n    top: 50px;\n    display: block;\n    width: 100%;\n  }\n\n  nav.navbar .brand-text {\n    display: none !important;\n  }\n\n  nav.navbar .brand-text.visible {\n    display: none !important;\n  }\n\n  nav.navbar .brand-text.brand-sm {\n    display: block !important;\n  }\n}\n\n@media (max-width: 991px) {\n  nav.navbar .dropdown-menu {\n    right: -140px;\n  }\n\n  nav.navbar .megamenu {\n    right: 0 !important;\n  }\n\n  nav.navbar a.nav-link {\n    font-size: 0.85rem;\n  }\n\n  nav.navbar .nav-link .badge {\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    color: #fff;\n    text-align: center;\n    font-size: 0.6rem;\n  }\n}\n\n@media (max-width: 575px) {\n  nav.navbar .dropdown {\n    position: static;\n  }\n\n  nav.navbar .dropdown-menu {\n    width: 90vw;\n    right: 2.5vw;\n    left: 2.5vw;\n    margin: 0 auto;\n  }\n\n\n}\n\n/*\n* ==========================================================\n*     SIDEBAR\n* ==========================================================\n*/\nnav#sidebar {\n  width: 240px;\n  /* margin-top: 60px; */\n  background:#1a1c1f;\n  color: #0e1115;\n  border-right: 1px solid #2D3034;\n  /* shrinked navbar */\n  /* background-color: #fff; */\n  position: relative;\n  padding-bottom: 90px;\n  \n}\n\nnav#sidebar a {\n  color: inherit;\n  text-decoration: none;\n  position: relative;\n}\n\nnav#sidebar a[aria-haspopup=\"menu\"]::after,\nnav#sidebar button[aria-haspopup=\"menu\"]::after {\n  content: \"\\e901\";\n  display: inline-block;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  font-family: 'icomoon' !important;\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  font-size: 11px;\n}\n\nnav#sidebar a[aria-haspopup=\"menu\"][aria-expanded=\"true\"]::after,\nnav#sidebar button[aria-haspopup=\"menu\"][aria-expanded=\"true\"]::after {\n  -webkit-transform: translateY(-50%) rotate(180deg);\n  transform: translateY(-50%) rotate(180deg);\n}\n\n\nnav#sidebar.shrinked a[aria-haspopup=\"menu\"]::after {\n  content: \"\\f107\";\n  transform: translate(-50%, -50%);\n  position: absolute;\n  top: 90%;\n  left: 50%;\n}\n\nnav#sidebar.shrinked a[aria-haspopup=\"menu\"][aria-expanded=\"true\"]::after {\n  content: \"\\f106\";\n}\n\nnav#sidebar span.heading {\n  font-weight: 700;\n  margin-left: 20px;\n  color: #494d53;\n  font-size: 1.2rem;\n  margin-bottom: 15px;\n}\n\nnav#sidebar .avatar {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin-right: 15px;\n  background: none;\n  padding: 4px;\n}\n\nnav#sidebar.shrinked .avatar {\n  margin-right: 0px;\n}\n\nnav#sidebar ul {\n  max-height: none;\n  padding-bottom: 0px;\n}\n\nnav#sidebar li {\n  position: relative;\n  margin: 0px;\n}\n\nnav#sidebar li a {\n  padding: 12px 12px;\n  display: block;\n  font-size: 15px;\n  font-weight: 400;\n  position: relative;\n  z-index: 1;\n  border: none;\n  color: #7B7A7A;\n  line-height: normal;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n}\n\n\nnav#sidebar li a .icon, nav#sidebar li>.btn.sgds .icon {\n    margin: 0 7px 0 0;\n    font-size: 16px;\n    flex: 0 0 20px;\n}\n\nnav#sidebar li a .icon svg.menu-item-icon {\n    height: 19px;\n    width: auto;\n}\n\nnav#sidebar li a .icon.icon-user-management, nav#sidebar li a .icon.icon-team-management,  nav#sidebar li a .icon.icon-profile-settings, \nnav#sidebar li a .icon.icon-help, nav#sidebar li a .icon.icon-settings {\n   font-size: 17px;\n}\n\nnav#sidebar li a .icon.icon-leaderboard{\n  font-size: 18px;\n}\n\nnav#sidebar li a:hover {\n  color: #ed5a28;\n}\n\n\nnav#sidebar li a:focus {\n  box-shadow: none;\n}\n\nnav#sidebar li a[aria-expanded=\"true\"]:before {\n  opacity: 1;\n}\n\n\nnav#sidebar li.selected .sidenav-collapse li a.active:before,\nnav#sidebar li.selected .sidenav-collapse li a.active:hover:before {\n  background: #10688B;\n  opacity: 1;\n}\n\n#sidebar .sidenav-collapse {\n  margin: 0px;\n}\n\nnav#sidebar li.active>a {\n    background: rgb(230 113 37 / 18%);\n    color: #ed5a28;\n    font-weight: 600;\n}\n\nnav#sidebar li li.active>a {\n  background: rgb(84, 178, 203);\n}\n\nnav#sidebar li>.btn.sgds {\n  padding: 12px 12px;\n  font-size: 15px;\n  font-weight: 400;\n  position: relative;\n  z-index: 1;\n  border: none;\n  color: #7B7A7A;\n  line-height: normal;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: flex-start;\n}\n\nnav#sidebar li.active>.btn.sgds {\n    background: rgba(3, 189, 90, 0.18);\n    color: #0CA751;\n    font-weight: bold;\n}\n\nnav#sidebar li>.btn.sgds:focus {\n    outline: none;\n    box-shadow: none;\n}\n\nnav#sidebar li.active>.btn.sgds .icon-traininig {\n  font-size: 18px;\n}\n\nnav#sidebar li .sidenav-collapse ul li a {\n    font-size: 14px;\n    padding: 9px 12px 9px 20px;\n}\n\nnav#sidebar.shrinked {\n  width: 80px;\n}\n\n\nnav#sidebar.shrinked span.heading {\n  margin-left: 0;\n  display: block;\n  text-align: center;\n  font-size: 1rem;\n}\n\nnav#sidebar.shrinked ul {\n  max-height: none;\n}\n\nnav#sidebar.shrinked ul a {\n  padding: 14px 5px;\n  display: block;\n  font-weight: 400;\n  text-align: center;\n  font-size: 0.8rem;\n  word-break: break-word;\n}\n\nnav#sidebar.shrinked ul i {\n  font-size: 1.2rem;\n  text-align: center !important;\n  width: 100%;\n  display: block !important;\n  border: none !important;\n  padding: 0 !important;\n}\n\nnav#sidebar.shrinked ul ul a {\n  padding-left: 10px;\n}\n\nnav#sidebar.shrinked a[data-bs-toggle=\"collapse\"]::after {\n  content: \"\\f107\";\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  position: absolute;\n  top: 88%;\n  left: 50%;\n}\n\nnav#sidebar.shrinked a[aria-expanded=\"true\"]::after {\n  content: \"\\f106\";\n}\n\n/* Sidebar Media Query ----------------------------------- */\n\n@media (min-width: 991px) {\n  nav#sidebar {\n    transition: margin, 0.25s ease-out;\n    margin-left: 0px;\n    flex: 0 0 240px;\n  }\n\n  .sideMenuFixed nav#sidebar {\n    margin-left: 0px;\n  }\n\n  nav#sidebar+.page-content {\n    /* width: auto; */\n    flex: auto;\n  }\n\n\n  /* nav.navbar .sidebar-toggle {\n    display: none;\n  } */\n\n}\n\n@media (max-width: 991px) {\n  .page-content {\n    width: 100%;\n  }\n\n  .page-content.active {\n    width: calc(100% - 80px);\n  }\n\n  nav#sidebar {\n    /* width: 15%; */\n    margin-left: 0px;\n    flex: 0 0 222px;\n    position: fixed;\n    left: -222px;\n    top: 68.79px;\n    bottom: 0;\n    transition: left, 0.25s ease-out;\n    z-index: 99;\n  }\n\n  .sideBarSticky {\n    height: calc(100vh - 73px);\n    overflow-y: auto;\n  }\n\n  .sideMenuFixed nav#sidebar {\n    left: 0;\n  }\n\n\n\n  nav#sidebar li a {\n    padding: 16px 18px;\n    font-size: 14px;\n  }\n\n  nav#sidebar li a i,\n  nav#sidebar li button.btn i {\n    margin: -2px 7px 0px 0;\n  }\n\n  nav.navbar .dropdown {\n    border-left: none;\n    margin-left: 8px;\n  }\n\n  nav.navbar .sidebar-toggle {\n    margin: 0 0 0 10px;\n  }\n\n\n\n  nav#sidebar span.heading {\n    margin-left: 0;\n    display: block;\n    text-align: center;\n    font-size: 1rem;\n  }\n\n  nav#sidebar ul {\n    max-height: none;\n  } \n}\n\n@media (min-width: 991px) {\n  .statistic-block {\n    padding: 20px;\n    background: #fff;\n    color: #000000;\n    border: 1px solid #E8E8E8;\n  }\n\n  .statistic-block .title {\n    margin-bottom: 0;\n  }\n\n  .statistic-block strong,\n  .statistic-block span {\n    display: block;\n  }\n\n  .statistic-block strong {\n    text-transform: none;\n    letter-spacing: 0.1em;\n    font-size: 0.9rem;\n    color: #8a8d93;\n    margin-bottom: 5px;\n  }\n\n  .statistic-block .icon {\n    margin-bottom: 5;\n    font-size: 1.2rem;\n    color: #8a8d93;\n  }\n\n  .statistic-block .number {\n    color: inherit;\n    font-size: 2.2rem;\n  }\n\n  .progress-bar {\n    background-color: #1D68E0;\n  }\n\n  .progress.progress-template {\n    width: 100%;\n    height: 4px;\n    border-radius: 30px;\n    overflow: hidden;\n    background: #393c43;\n    margin-top: 5px;\n  }\n\n  .progress.progress-template.progress-small {\n    height: 2px;\n  }\n\n  .progress-bar.progress-bar-template {\n    height: 4px;\n    border-radius: 30px;\n  }\n\n  .progress-bar.progress-bar-template.progress-bar-small {\n    height: 2px;\n  }\n\n \n  /* Scans Block */\n  .stats-2-block .stats-2 {\n    width: 50%;\n    color: #8a8d93;\n    position: relative;\n    padding-right: 50px;\n  }\n\n  .stats-2-block .stats-2::after {\n    content: \"\";\n    background: #40444b;\n    width: 1px;\n    height: 80%;\n    display: block;\n    position: absolute;\n    top: 10%;\n    right: 30px;\n  }\n\n  .stats-2-block .stats-2:last-of-type {\n    padding-right: 0;\n  }\n\n  .stats-2-block .stats-2:last-of-type::after {\n    display: none;\n  }\n\n  .stats-2-block span,\n  .stats-2-block strong {\n    color: inherit;\n  }\n\n  .stats-2-block strong {\n    font-size: 2rem;\n  }\n\n  .stats-2-block span {\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    font-weight: 300;\n    font-size: 0.9rem;\n  }\n\n  .stats-2-block .progress {\n    margin-top: 10px;\n    max-width: 150px;\n  }\n\n  .stats-2-block .stats-2-arrow {\n    -webkit-transform: translateY(10px);\n    transform: translateY(10px);\n    margin-right: 10px;\n  }\n\n  .stats-2-block .stats-2-arrow.low {\n    color: #dc3545;\n  }\n\n  .stats-2-block .stats-2-arrow.height {\n    color: #28a745;\n  }\n}\n\n/* Scans Block Media Query ------------------ */\n@media (max-width: 991px) {\n  .stats-2-block .stats-2::after {\n    display: none;\n  }\n}\n\n/* Requests Block */\n.stats-3-block .stats-3 {\n  width: 50%;\n  color: #8a8d93;\n  position: relative;\n  padding-right: 50px;\n}\n\n.stats-3-block .stats-3::after {\n  content: \"\";\n  background: #40444b;\n  width: 1px;\n  height: 80%;\n  display: block;\n  position: absolute;\n  top: 10%;\n  right: 30px;\n}\n\n.stats-3-block .stats-3:last-of-type {\n  padding-right: 0;\n}\n\n.stats-3-block .stats-3:last-of-type::after {\n  display: none;\n}\n\n.stats-3-block span,\n.stats-3-block strong {\n  color: inherit;\n}\n\n.stats-3-block strong {\n  font-size: 2rem;\n}\n\n.stats-3-block strong.strong-sm {\n  font-size: 1.4rem;\n}\n\n.stats-3-block span {\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-weight: 300;\n  font-size: 0.9rem;\n  font-weight: 400;\n}\n\n.stats-3-block span.span-sm {\n  font-size: 0.85rem;\n}\n\n.stats-3-block .progress {\n  margin-top: 10px;\n  background: #393c43;\n  max-width: 150px;\n}\n\n.stats-3-block .item {\n  width: 50%;\n}\n\n.stats-3-block .item .line {\n  display: block;\n  margin: 10px auto;\n  width: 30px;\n  height: 1px;\n  background: #40444b;\n}\n\n.stats-3-block small {\n  font-weight: 700;\n}\n\n/* Requests Block Media Query ------------------ */\n@media (max-width: 991px) {\n  .stats-3-block .stats-3::after {\n    display: none;\n  }\n}\n\n\n/* user block */\n.user-block .avatar {\n  display: block;\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  margin: 15px auto;\n  position: relative;\n}\n\n.user-block .avatar img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n}\n\n.user-block .avatar .order {\n  width: 22px;\n  height: 22px;\n  line-height: 23px;\n  border-radius: 50%;\n  color: #fff;\n  position: absolute;\n  bottom: 0px;\n  right: 0px;\n  font-size: 0.7rem;\n}\n\n.user-block h3 {\n  margin-bottom: 0;\n}\n\n.user-block span {\n  font-weight: 300;\n  color: #75787f;\n}\n\n.user-block .contributions {\n  margin-top: 20px;\n  border-radius: 50px;\n  padding: 6px 30px;\n  background: #26292d;\n  display: inline-block;\n  font-size: 0.9rem;\n}\n\n.user-block .details {\n  margin-top: 40px;\n}\n\n.user-block .item {\n  width: 33.3333%;\n  text-align: center;\n}\n\n.user-block .item i {\n  margin-right: 10px;\n  color: #6a6c70;\n}\n\n.user-block a.user-title {\n  display: block;\n  text-decoration: none;\n  color: #8a8d93;\n  margin-top: 10px;\n}\n\n/* Public user Block */\n.public-user-block .avatar {\n  min-width: 50px;\n  max-width: 50px;\n  min-height: 50px;\n  max-height: 50px;\n  border-radius: 50%;\n  margin-left: 15px;\n  margin-right: 15px;\n  position: relative;\n  overflow: hidden;\n}\n\n.public-user-block .avatar img {\n  width: 100%;\n  height: 100%;\n}\n\n.public-user-block strong {\n  font-size: 1.2rem;\n}\n\n.public-user-block span {\n  font-size: 0.9rem;\n  font-weight: 300;\n}\n\n.public-user-block .contributions {\n  border-radius: 50px;\n  padding: 6px 30px;\n  background: #26292d;\n  display: inline-block;\n  font-size: 0.9rem;\n}\n\n.public-user-block .item {\n  width: 33.3333%;\n  text-align: center;\n}\n\n.public-user-block .item i {\n  margin-right: 10px;\n  color: #6a6c70;\n}\n\n.public-user-block .item strong {\n  font-size: 0.9rem;\n}\n\n.public-user-block .order {\n  font-size: 0.9rem;\n  font-weight: 700;\n}\n\n.public-user-block a.name {\n  text-decoration: none;\n  color: #8a8d93;\n}\n\n/* Public users Block Media Query ------------------ */\n@media (max-width: 991px) {\n  .public-user-block .contributions {\n    margin: 20px 0;\n  }\n\n  .public-user-block .order {\n    display: none !important;\n  }\n}\n\n/*\n* ==========================================================\n*     SALES SECTION\n* ==========================================================\n*/\n/* Sale Block */\n.stats-with-chart-2 .title {\n  margin-bottom: 30px;\n}\n\n.stats-with-chart-2 .title strong {\n  font-size: 1.25rem;\n}\n\n.stats-with-chart-2 .title span {\n  font-weight: 300;\n  font-size: 0.95rem;\n}\n\n.stats-with-chart-2 .chart {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.stats-with-chart-2 .text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  display: inline-block;\n  text-align: center;\n}\n\n.stats-with-chart-2 .text strong {\n  font-size: 1.5rem;\n}\n\n.stats-with-chart-2 .text span {\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-weight: 300;\n}\n\n/* Sales Difference Block */\n.stats-with-chart-1 {\n  height: 100%;\n}\n\n.stats-with-chart-1 .title {\n  margin-bottom: 30px;\n}\n\n.stats-with-chart-1 .title strong {\n  font-size: 1.25rem;\n}\n\n.stats-with-chart-1 .title span {\n  font-weight: 300;\n  font-size: 0.95rem;\n}\n\n.stats-with-chart-1 .text strong {\n  font-size: 1.8rem !important;\n  font-weight: 300;\n}\n\n/* Sales Difference Block Media Query ------------------ */\n@media (max-width: 991px) {\n  .stats-with-chart-1 {\n    height: auto;\n  }\n}\n\n/*\n* ==========================================================\n*     FEEDS SECTION\n* ==========================================================\n*/\n/* Checklist Media Query */\n.checklist-block .title {\n  margin-bottom: 20px;\n}\n\n.checklist-block .title strong {\n  font-size: 1.25rem;\n}\n\n.checklist-block .title span {\n  font-weight: 300;\n  font-size: 0.95rem;\n}\n\n.checklist-block label {\n  font-size: 0.9rem;\n  color: #8a8d93;\n  line-height: 1.8em;\n  margin-bottom: 0;\n}\n\n.checklist-block .item {\n  padding: 26px;\n}\n\n.checklist-block .item:nth-of-type(even) {\n  background: #282b2f;\n}\n\n.checklist-block input:checked+label {\n  text-decoration: line-through;\n}\n\n/* Messages Media Query */\n.messages-block a.message {\n  color: #8a8d93;\n  text-decoration: none;\n  padding: 10px;\n  border-bottom: 1px solid #282b2f;\n}\n\n.messages-block a.message:hover {\n  background: #282b2f;\n}\n\n.messages-block a.message:last-of-type {\n  border-bottom: none;\n}\n\n.messages-block .title {\n  margin-bottom: 30px;\n}\n\n.messages-block .title strong {\n  font-size: 1.25rem;\n}\n\n.messages-block .title span {\n  font-weight: 300;\n  font-size: 0.95rem;\n}\n\n.messages-block .profile {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  margin-right: 15px;\n  position: relative;\n}\n\n.messages-block .profile img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n}\n\n.messages-block .profile .status {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  position: absolute;\n  top: 2px;\n  right: 2px;\n}\n\n.messages-block .profile .status.online {\n  background: #28a745;\n}\n\n.messages-block .profile .status.away {\n  background: #ffc107;\n}\n\n.messages-block .profile .status.busy {\n  background: #dc3545;\n}\n\n.messages-block .profile .status.offline {\n  background: #999;\n}\n\n.messages-block .content strong {\n  font-size: 1.1rem;\n}\n\n.messages-block .content span {\n  font-weight: 300;\n}\n\n.messages-block .content .date {\n  color: #70737a;\n}\n\n/* Modal */\n.modal-open .modal {\n  z-index: 9999;\n}\n\n.modal-open .modal .modal-content {\n  border-radius: 4px;\n}\n\n.modal .modal-header {\n  padding-top: 24px;\n  padding-top: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n\n\n.modal-open .modal .close {\n  color: #8a8d93;\n  opacity: 1;\n}\n\n.close {\n  float: right;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: 0.5;\n}\n\n\n.modal-content .modal-header .btn-close {\n  padding: 0;\n  margin: 0 -10px 0 0;\n  width: 30px;\n  height: 30px;\n  background: none;\n  opacity: 1;\n  background: #E5E5E5;\n}\n\n.modal .modal-content .modal-body {\n  padding: 28px 26px;\n}\n\n.modal-content .modal-header .btn-close:before {\n  content: \"\\e90e\";\n  font-family: 'icomoon' !important;\n  color: #000;\n  font-size: 11px;\n}\n\n\n\n/*\n* ==========================================================\n*       UTILITIES\n* ==========================================================\n*/\n.bg-cover {\n  background-size: cover;\n}\n\n.bg-gray-dark {\n  background: #2d3035;\n}\n\n.bg-gray-darker {\n  background: #22252a;\n}\n\n/*\n* ==========================================================\n*     FORMS\n* ==========================================================\n*/\n.form-control {\n  /* height: calc(2.4rem + 2px); */\n  border: 1px solid #444951;\n  background: transparent;\n  border-radius: 0;\n  color: #979a9f;\n  /* padding: 0.45rem 0.75rem; */\n}\n\n.form-control::-moz-placeholder {\n  font-size: 0.9rem;\n  /* font-family: \"Muli\", sans-serif; */\n  color: #535353;\n}\n\n.form-control::-webkit-input-placeholder {\n  font-size: 0.9rem;\n  /* font-family: \"Muli\", sans-serif; */\n  color: #535353;\n}\n\n.form-control:-ms-input-placeholder {\n  font-size: 0.9rem;\n  /* font-family: \"Muli\", sans-serif; */\n  color: #535353;\n}\n\n.form-control:focus {\n  color: #979a9f;\n  background-color: transparent;\n  border-color: #2186AD;\n  outline: none;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(219, 101, 116, 0.25);\n  box-shadow: 0 0 0 0.2rem rgba(219, 101, 116, 0.25);\n}\n\n.form-control:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.form-control:disabled,\n.form-control[readonly] {\n  background: #444951;\n}\n\n.form-control-sm {\n  height: calc(1.8125rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.form-control-lg {\n  height: calc(2.875rem + 2px);\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n\n.form-control-label {\n  color: #777;\n  margin: 8px 0px;\n}\n\nbutton,\ninput[type=\"submit\"] {\n  cursor: pointer;\n  font-family: inherit;\n  /* font-weight: 300 !important; */\n}\n\n.custom-select {\n  height: calc(2.4rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  line-height: 1.5;\n  color: #8a8d93;\n  vertical-align: middle;\n  background: transparent url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23495057' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right 0.75rem center;\n  background-size: 8px 10px;\n  border: 1px solid #444951;\n  border-radius: 0;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.custom-select:focus {\n  border-color: #2186AD;\n  outline: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.custom-select:focus::-ms-value {\n  color: #495057;\n  background-color: transparent;\n}\n\n.custom-select[multiple],\n.custom-select[size]:not([size=\"1\"]) {\n  height: auto;\n  padding-right: 0.75rem;\n  background-image: none;\n}\n\n.custom-select:disabled {\n  color: #868e96;\n  background-color: #e9ecef;\n}\n\n.custom-select::-ms-expand {\n  opacity: 0;\n}\n\n.custom-select-sm {\n  height: calc(1.8125rem + 2px);\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  font-size: 75%;\n}\n\n.custom-select-lg {\n  height: calc(2.875rem + 2px);\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  font-size: 125%;\n}\n\n.input-group-text {\n  background: #363a40;\n  color: #8a8d93;\n  font-weight: 300;\n  border-radius: 0;\n  border: 1px solid #444951;\n  line-height: 1.5rem;\n}\n\n.input-group-text .checkbox-template,\n.input-group-text .radio-template {\n  -webkit-transform: none;\n  transform: none;\n}\n\n.input-group .dropdown-menu {\n  padding: 15px;\n  color: #777;\n  border-radius: 0;\n  margin-top: 5px;\n}\n\n.input-group .dropdown-menu a {\n  padding: 5px 0;\n  color: inherit;\n  text-decoration: none;\n  display: block;\n}\n\n.input-group .dropdown-menu a:hover {\n  color: #2186AD;\n  background: none !important;\n}\n\nform label {\n  font-size: 0.9rem;\n  color: #8a8d93;\n  margin: 8px 0;\n}\n\n.checkbox-template,\n.radio-template {\n  -webkit-transform: translateY(1px);\n  transform: translateY(1px);\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  cursor: pointer;\n  position: relative;\n  outline: none;\n}\n\n.checkbox-template+label,\n.radio-template+label {\n  margin-left: 15px;\n}\n\n.checkbox-template::before,\n.radio-template::before {\n  margin-right: 10px;\n  content: \"\";\n  display: inline-block;\n  -webkit-transform: translate(-2px, -2px);\n  transform: translate(-2px, -2px);\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n  text-align: center;\n  background: #8a8d93;\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n}\n\n.checkbox-template::after,\n.radio-template::after {\n  content: \"\\f00c\";\n  width: 12px;\n  height: 12px;\n  line-height: 12px;\n  text-align: center;\n  display: block;\n  font-family: \"FontAwesome\";\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  font-size: 0.6rem;\n  opacity: 0;\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n  color: #fff;\n}\n\n.checkbox-template:checked::before,\n.radio-template:checked::before {\n  background: #2186AD;\n}\n\n.checkbox-template:checked::after,\n.radio-template:checked::after {\n  opacity: 1;\n}\n\n.radio-template::before {\n  border-radius: 50%;\n  -webkit-transform: translate(-3px, -3px);\n  transform: translate(-3px, -3px);\n}\n\n.radio-template::after {\n  width: 6px;\n  height: 6px;\n  line-height: 6px;\n  text-align: center;\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  border-radius: 50%;\n  content: \"\";\n}\n\n.radio-template:checked::after {\n  background: #fff;\n}\n\ninput.input-material {\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid #444951;\n  padding: 10px 0;\n  background: none;\n  color: #8a8d93;\n}\n\ninput.input-material.is-invalid {\n  border-color: #bb414d !important;\n}\n\ninput.input-material:focus {\n  border-color: #2186AD;\n}\n\ninput.input-material~label {\n  color: #aaa;\n  position: absolute;\n  top: 14px;\n  left: 0;\n  cursor: text;\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n  font-weight: 300;\n}\n\ninput.input-material~label.active {\n  font-size: 0.85rem;\n  top: -10px;\n  color: #2186AD;\n}\n\ninput.input-material~label.is-invalid~label {\n  color: #bb414d;\n}\n\n.form-group-material {\n  position: relative;\n  margin-bottom: 30px;\n}\n\n.custom-select.is-invalid:focus,\n.form-control.is-invalid:focus,\n.was-validated .custom-select:invalid:focus,\n.was-validated .form-control:invalid:focus,\n.custom-select.is-valid:focus,\n.form-control.is-valid:focus,\n.was-validated .custom-select:valid:focus,\n.was-validated .form-control:valid:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.form-page .block {\n  margin-bottom: 30px;\n}\n\n/*\n* ==========================================================\n*     CHARTS\n* ==========================================================\n*/\n.gauge-container {\n  position: relative;\n}\n\n.gauge-canvas {\n  display: block;\n  max-width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.gauge-label {\n  display: inline-block;\n  position: absolute;\n  left: 50%;\n  bottom: 50px;\n  font-size: 1.2rem;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n\n.sparklines {\n  display: inline-block;\n  margin-left: 20px;\n}\n\n/*\n* ==========================================================\n*     TABLES\n* ==========================================================\n*/\n.table {\n  margin-bottom: 20px;\n  color: #8a8d93;\n}\n\n.table td,\n.table th {\n  border-color: #C9C7C7;\n}\n\n.table thead th {\n  border: none;\n}\n\n.table-striped tbody tr {\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: #282b2f;\n  color: #8a8d93 !important;\n}\n\n.table-striped tbody tr:nth-of-type(odd):hover {\n  background-color: #26292d;\n}\n\n.table-bordered td,\n.table-bordered th {\n  border-color: #C9C7C7;\n}\n\n@media (max-width: 991px) {\n  section.tables {\n    padding: 0;\n  }\n}\n\n/*\n=====================\nSTYLE SWITCHER FOR DEMO\n=====================\n*/\n#style-switch-button {\n  position: fixed;\n  top: 120px;\n  right: 0px;\n  border-radius: 0;\n  z-index: 2;\n}\n\n#style-switch {\n  width: 300px;\n  padding: 20px;\n  position: fixed;\n  top: 160px;\n  right: 0;\n  background: #22252a;\n  border: solid 1px #6a6c70;\n  z-index: 2000;\n}\n\n/* =========================================\n   THEMING OF BOOTSTRAP COMPONENTS\n   ========================================= */\n/*\n * 1. NAVBAR\n */\n.navbar {\n  padding: 0.5rem 1rem;\n}\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.3125rem;\n  padding-bottom: 0.3125rem;\n  margin-right: 1rem;\n  font-size: 1.25rem;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.25rem;\n  line-height: 1;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-brand:focus,\n.navbar-light .navbar-brand:hover {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.navbar-light .navbar-nav .nav-link:focus,\n.navbar-light .navbar-nav .nav-link:hover {\n  color: rgba(0, 0, 0, 0.7);\n}\n\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.navbar-light .navbar-nav .show>.nav-link,\n.navbar-light .navbar-nav .active>.nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.5);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n}\n\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.navbar-dark .navbar-brand {\n  color: #fff;\n}\n\n.navbar-dark .navbar-brand:focus,\n.navbar-dark .navbar-brand:hover {\n  color: #fff;\n}\n\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.navbar-dark .navbar-nav .nav-link:focus,\n.navbar-dark .navbar-nav .nav-link:hover {\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.25);\n}\n\n.navbar-dark .navbar-nav .show>.nav-link,\n.navbar-dark .navbar-nav .active>.nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fff;\n}\n\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n}\n\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/*\n * 2. BUTTONS\n */\n.btn {\n  font-weight: 400;\n  border: 1px solid transparent;\n  padding: 0.6rem 16px 0.45rem;\n  font-size: 1rem;\n  line-height: 1.39rem;\n  border-radius: 0.25rem;\n  -webkit-transition: color 0.15s ease-in-out,\n    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n    -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n    -webkit-box-shadow 0.15s ease-in-out;\n}\n\n.btn:focus,\n.btn.focus {\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(219, 101, 116, 0.25);\n  box-shadow: 0 0 0 0.2rem rgba(219, 101, 116, 0.25);\n}\n\n.btn.disabled,\n.btn:disabled {\n  opacity: 0.65;\n}\n\n.btn:not([disabled]):not(.disabled):active,\n.btn:not([disabled]):not(.disabled).active {\n  background-image: none;\n}\n\n.btn-primary {\n  color: color-yiq(#2186AD);\n  background-color: #2186AD;\n  border-color: #2186AD;\n}\n\n.btn-primary:hover {\n  color: color-yiq(#139DD3);\n  background-color: #139DD3;\n  border-color: #139DD3\n}\n\n.btn-primary:focus,\n.btn-primary.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(21, 113, 146, 0.2);\n  box-shadow: 0 0 0 0.2rem rgba(21, 113, 146, 0.2);\n  background-color: #0277A4;\n  border-color: #0277A4;\n}\n\n.btn-primary.disabled,\n.btn-primary:disabled {\n  color: color-yiq(#2186AD);\n  background-color: #444951;\n  border-color: #444951;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active,\n.btn-primary:not(:disabled):not(.disabled).active,\n.show>.btn-primary.dropdown-toggle {\n  color: color-yiq(#199DD0);\n  background-color: #139DD3;\n  border-color: #199DD0;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active:focus,\n.btn-primary:not(:disabled):not(.disabled).active:focus,\n.show>.btn-primary.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(21, 113, 146, 0.2);\n  box-shadow: 0 0 0 0.2rem rgba(21, 113, 146, 0.2);\n}\n\n.btn-secondary {\n  color: color-yiq(#868e96);\n  background-color: #868e96;\n  border-color: #868e96;\n}\n\n.btn-secondary:hover {\n  color: color-yiq(#727b84);\n  background-color: #727b84;\n  border-color: #6c757d;\n}\n\n.btn-secondary:focus,\n.btn-secondary.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(134, 142, 150, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(134, 142, 150, 0.5);\n}\n\n.btn-secondary.disabled,\n.btn-secondary:disabled {\n  color: color-yiq(#868e96);\n  background-color: #868e96;\n  border-color: #868e96;\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active,\n.btn-secondary:not(:disabled):not(.disabled).active,\n.show>.btn-secondary.dropdown-toggle {\n  color: color-yiq(#6c757d);\n  background-color: #6c757d;\n  border-color: #666e76;\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active:focus,\n.btn-secondary:not(:disabled):not(.disabled).active:focus,\n.show>.btn-secondary.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(134, 142, 150, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(134, 142, 150, 0.5);\n}\n\n.btn-success {\n  color: color-yiq(#28a745);\n  background-color: #28a745;\n  border-color: #28a745;\n}\n\n.btn-success:hover {\n  color: color-yiq(#218838);\n  background-color: #218838;\n  border-color: #1e7e34;\n}\n\n.btn-success:focus,\n.btn-success.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n}\n\n.btn-success.disabled,\n.btn-success:disabled {\n  color: color-yiq(#28a745);\n  background-color: #28a745;\n  border-color: #28a745;\n}\n\n.btn-success:not(:disabled):not(.disabled):active,\n.btn-success:not(:disabled):not(.disabled).active,\n.show>.btn-success.dropdown-toggle {\n  color: color-yiq(#1e7e34);\n  background-color: #1e7e34;\n  border-color: #1c7430;\n}\n\n.btn-success:not(:disabled):not(.disabled):active:focus,\n.btn-success:not(:disabled):not(.disabled).active:focus,\n.show>.btn-success.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n}\n\n.btn-info {\n  color: color-yiq(#17a2b8);\n  background-color: #17a2b8;\n  border-color: #17a2b8;\n}\n\n.btn-info:hover {\n  color: color-yiq(#138496);\n  background-color: #138496;\n  border-color: #117a8b;\n}\n\n.btn-info:focus,\n.btn-info.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n}\n\n.btn-info.disabled,\n.btn-info:disabled {\n  color: color-yiq(#17a2b8);\n  background-color: #17a2b8;\n  border-color: #17a2b8;\n}\n\n.btn-info:not(:disabled):not(.disabled):active,\n.btn-info:not(:disabled):not(.disabled).active,\n.show>.btn-info.dropdown-toggle {\n  color: color-yiq(#117a8b);\n  background-color: #117a8b;\n  border-color: #10707f;\n}\n\n.btn-info:not(:disabled):not(.disabled):active:focus,\n.btn-info:not(:disabled):not(.disabled).active:focus,\n.show>.btn-info.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n}\n\n.btn-warning {\n  color: color-yiq(#ffc107);\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n\n.btn-warning:hover {\n  color: color-yiq(#e0a800);\n  background-color: #e0a800;\n  border-color: #d39e00;\n}\n\n.btn-warning:focus,\n.btn-warning.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n\n.btn-warning.disabled,\n.btn-warning:disabled {\n  color: color-yiq(#ffc107);\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n\n.btn-warning:not(:disabled):not(.disabled):active,\n.btn-warning:not(:disabled):not(.disabled).active,\n.show>.btn-warning.dropdown-toggle {\n  color: color-yiq(#d39e00);\n  background-color: #d39e00;\n  border-color: #c69500;\n}\n\n.btn-warning:not(:disabled):not(.disabled):active:focus,\n.btn-warning:not(:disabled):not(.disabled).active:focus,\n.show>.btn-warning.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n\n.btn-danger {\n  color: color-yiq(#bb414d);\n  background-color: #bb414d;\n  border-color: #bb414d;\n  margin-left: 10px;\n}\n\n.btn-danger:hover {\n  color: color-yiq(#9f3741);\n  background-color: #9f3741;\n  border-color: #95343d;\n}\n\n.btn-danger:focus,\n.btn-danger.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(187, 65, 77, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(187, 65, 77, 0.5);\n}\n\n.btn-danger.disabled,\n.btn-danger:disabled {\n  color: color-yiq(#bb414d);\n  background-color: #bb414d;\n  border-color: #bb414d;\n}\n\n.btn-danger:not(:disabled):not(.disabled):active,\n.btn-danger:not(:disabled):not(.disabled).active,\n.show>.btn-danger.dropdown-toggle {\n  color: color-yiq(#95343d);\n  background-color: #95343d;\n  border-color: #8c313a;\n}\n\n.btn-danger:not(:disabled):not(.disabled):active:focus,\n.btn-danger:not(:disabled):not(.disabled).active:focus,\n.show>.btn-danger.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(187, 65, 77, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(187, 65, 77, 0.5);\n}\n\n.btn-light {\n  color: color-yiq(#e9ecef);\n  background-color: #e9ecef;\n  border-color: #e9ecef;\n}\n\n.btn-light:hover {\n  color: color-yiq(#d3d9df);\n  background-color: #d3d9df;\n  border-color: #cbd3da;\n}\n\n.btn-light:focus,\n.btn-light.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(233, 236, 239, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(233, 236, 239, 0.5);\n}\n\n.btn-light.disabled,\n.btn-light:disabled {\n  color: color-yiq(#e9ecef);\n  background-color: #e9ecef;\n  border-color: #e9ecef;\n}\n\n.btn-light:not(:disabled):not(.disabled):active,\n.btn-light:not(:disabled):not(.disabled).active,\n.show>.btn-light.dropdown-toggle {\n  color: color-yiq(#cbd3da);\n  background-color: #cbd3da;\n  border-color: #c4ccd4;\n}\n\n.btn-light:not(:disabled):not(.disabled):active:focus,\n.btn-light:not(:disabled):not(.disabled).active:focus,\n.show>.btn-light.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(233, 236, 239, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(233, 236, 239, 0.5);\n}\n\n.btn-dark {\n  color: color-yiq(#212529);\n  background-color: #212529;\n  border-color: #212529;\n}\n\n.btn-dark:hover {\n  color: color-yiq(#101214);\n  background-color: #101214;\n  border-color: #0a0c0d;\n}\n\n.btn-dark:focus,\n.btn-dark.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);\n}\n\n.btn-dark.disabled,\n.btn-dark:disabled {\n  color: color-yiq(#212529);\n  background-color: #212529;\n  border-color: #212529;\n}\n\n.btn-dark:not(:disabled):not(.disabled):active,\n.btn-dark:not(:disabled):not(.disabled).active,\n.show>.btn-dark.dropdown-toggle {\n  color: color-yiq(#0a0c0d);\n  background-color: #0a0c0d;\n  border-color: #050506;\n}\n\n.btn-dark:not(:disabled):not(.disabled):active:focus,\n.btn-dark:not(:disabled):not(.disabled).active:focus,\n.show>.btn-dark.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);\n}\n\n.btn.btn-outline-primary {\n  color: #000000;\n  background-color: transparent;\n  background-image: none;\n  border:1px solid #000000;\n}\n\n.btn.btn-outline-primary:hover {\n  color:#f97315;\n  background-color:transparent;\n  border-color: #f97315;\n}\n\n.btn-outline-primary:focus,\n.btn-outline-primary.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);\n}\n\n.btn-outline-primary.disabled,\n.btn-outline-primary:disabled {\n  color: #2186AD;\n  background-color: transparent;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled):active,\n.btn-outline-primary:not(:disabled):not(.disabled).active,\n.show>.btn-outline-primary.dropdown-toggle {\n  color: color-yiq(#2186AD);\n  background-color: #2186AD;\n  border-color: #2186AD;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus,\n.btn-outline-primary:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-primary.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.2);\n  box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.2);\n}\n\n.btn-outline-secondary {\n  color: #868e96;\n  background-color: transparent;\n  background-image: none;\n  border-color: #868e96;\n}\n\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #868e96;\n  border-color: #868e96;\n}\n\n.btn-outline-secondary:focus,\n.btn-outline-secondary.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(134, 142, 150, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(134, 142, 150, 0.5);\n}\n\n.btn-outline-secondary.disabled,\n.btn-outline-secondary:disabled {\n  color: #868e96;\n  background-color: transparent;\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled):active,\n.btn-outline-secondary:not(:disabled):not(.disabled).active,\n.show>.btn-outline-secondary.dropdown-toggle {\n  color: color-yiq(#868e96);\n  background-color: #868e96;\n  border-color: #868e96;\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,\n.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-secondary.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(134, 142, 150, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(134, 142, 150, 0.5);\n}\n\n.btn-outline-success {\n  color: #28a745;\n  background-color: transparent;\n  background-image: none;\n  border-color: #28a745;\n}\n\n.btn-outline-success:hover {\n  color: #fff;\n  background-color: #28a745;\n  border-color: #28a745;\n}\n\n.btn-outline-success:focus,\n.btn-outline-success.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n}\n\n.btn-outline-success.disabled,\n.btn-outline-success:disabled {\n  color: #28a745;\n  background-color: transparent;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled):active,\n.btn-outline-success:not(:disabled):not(.disabled).active,\n.show>.btn-outline-success.dropdown-toggle {\n  color: color-yiq(#28a745);\n  background-color: #28a745;\n  border-color: #28a745;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled):active:focus,\n.btn-outline-success:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-success.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n}\n\n.btn-outline-info {\n  color: #17a2b8;\n  background-color: transparent;\n  background-image: none;\n  border-color: #17a2b8;\n}\n\n.btn-outline-info:hover {\n  color: #fff;\n  background-color: #17a2b8;\n  border-color: #17a2b8;\n}\n\n.btn-outline-info:focus,\n.btn-outline-info.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n}\n\n.btn-outline-info.disabled,\n.btn-outline-info:disabled {\n  color: #17a2b8;\n  background-color: transparent;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled):active,\n.btn-outline-info:not(:disabled):not(.disabled).active,\n.show>.btn-outline-info.dropdown-toggle {\n  color: color-yiq(#17a2b8);\n  background-color: #17a2b8;\n  border-color: #17a2b8;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled):active:focus,\n.btn-outline-info:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-info.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n}\n\n.btn-outline-warning {\n  color: #ffc107;\n  background-color: transparent;\n  background-image: none;\n  border-color: #ffc107;\n}\n\n.btn-outline-warning:hover {\n  color: #fff;\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n\n.btn-outline-warning:focus,\n.btn-outline-warning.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n\n.btn-outline-warning.disabled,\n.btn-outline-warning:disabled {\n  color: #ffc107;\n  background-color: transparent;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled):active,\n.btn-outline-warning:not(:disabled):not(.disabled).active,\n.show>.btn-outline-warning.dropdown-toggle {\n  color: color-yiq(#ffc107);\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus,\n.btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-warning.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n\n.btn-outline-danger {\n  color: #bb414d;\n  background-color: transparent;\n  background-image: none;\n  border-color: #bb414d;\n}\n\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #bb414d;\n  border-color: #bb414d;\n}\n\n.btn-outline-danger:focus,\n.btn-outline-danger.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(187, 65, 77, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(187, 65, 77, 0.5);\n}\n\n.btn-outline-danger.disabled,\n.btn-outline-danger:disabled {\n  color: #bb414d;\n  background-color: transparent;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled):active,\n.btn-outline-danger:not(:disabled):not(.disabled).active,\n.show>.btn-outline-danger.dropdown-toggle {\n  color: color-yiq(#bb414d);\n  background-color: #bb414d;\n  border-color: #bb414d;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus,\n.btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-danger.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(187, 65, 77, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(187, 65, 77, 0.5);\n}\n\n.btn-outline-light {\n  color: #e9ecef;\n  background-color: transparent;\n  background-image: none;\n  border-color: #e9ecef;\n}\n\n.btn-outline-light:hover {\n  color: #fff;\n  background-color: #e9ecef;\n  border-color: #e9ecef;\n}\n\n.btn-outline-light:focus,\n.btn-outline-light.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(233, 236, 239, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(233, 236, 239, 0.5);\n}\n\n.btn-outline-light.disabled,\n.btn-outline-light:disabled {\n  color: #e9ecef;\n  background-color: transparent;\n}\n\n.btn-outline-light:not(:disabled):not(.disabled):active,\n.btn-outline-light:not(:disabled):not(.disabled).active,\n.show>.btn-outline-light.dropdown-toggle {\n  color: color-yiq(#e9ecef);\n  background-color: #e9ecef;\n  border-color: #e9ecef;\n}\n\n.btn-outline-light:not(:disabled):not(.disabled):active:focus,\n.btn-outline-light:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-light.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(233, 236, 239, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(233, 236, 239, 0.5);\n}\n\n.btn-outline-dark {\n  color: #212529;\n  background-color: transparent;\n  background-image: none;\n  border-color: #212529;\n}\n\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #212529;\n  border-color: #212529;\n}\n\n.btn-outline-dark:focus,\n.btn-outline-dark.focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);\n}\n\n.btn-outline-dark.disabled,\n.btn-outline-dark:disabled {\n  color: #212529;\n  background-color: transparent;\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled):active,\n.btn-outline-dark:not(:disabled):not(.disabled).active,\n.show>.btn-outline-dark.dropdown-toggle {\n  color: color-yiq(#212529);\n  background-color: #212529;\n  border-color: #212529;\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus,\n.btn-outline-dark:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-dark.dropdown-toggle:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);\n  box-shadow: 0 0 0 0.2rem rgba(33, 37, 41, 0.5);\n}\n\n.btn-lg {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n\n.btn-sm {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n/*\n * 3. TYPE\n */\nbody {\n  /* font-family: \"Muli\", sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #8a8d93;\n  background-color: #fff; */\n}\n\nbody {\n  font-family: 'helvetica', sans-serif;\n}\n\na {\n  color: #000;\n  text-decoration: none;\n}\n\na:focus,\na:hover {\n  color: #c52e41;\n  text-decoration: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  margin-bottom: 0.5rem;\n  font-family: inherit;\n  font-weight: 700;\n  line-height: 1.2;\n  color: inherit;\n}\n\nh1,\n.h1 {\n  font-size: 2.5rem;\n}\n\nh2,\n.h2 {\n  font-size: 1.7rem;\n}\n\nh3,\n.h3 {\n  font-size: 1.5rem;\n}\n\nh4,\n.h4 {\n  font-size: 1.3rem;\n}\n\nh5,\n.h5 {\n  font-size: 1.1rem;\n  position: inherit !important;\n}\n\nh6,\n.h6 {\n  font-size: 1rem;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: 6rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-2 {\n  font-size: 5.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-3 {\n  font-size: 4.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-4 {\n  font-size: 3.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\nhr {\n  border-top: 1px solid #6a6c70;\n}\n\nsmall,\n.small {\n  font-size: 80%;\n  font-weight: 400;\n}\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n\n.blockquote {\n  padding: 0.5rem 1rem;\n  margin-bottom: 2rem;\n  font-size: 1.25rem;\n  border-left: 5px solid #2186AD;\n}\n\n.blockquote-footer {\n  color: #868e96;\n}\n\n.blockquote-footer::before {\n  content: \"\\2014 \\00A0\";\n}\n\n.text-primary {\n  color: #2186AD !important;\n}\n\na.text-primary:focus,\na.text-primary:hover {\n  color: #d13c4f !important;\n}\n\n/*\n * 4. PAGINATION\n */\n.pagination .page-item:first-child .page-link {\n  border-radius: 3px;\n}\n\n.pagination .page-item:last-child .page-link {\n  border-radius: 3px;\n}\n\n.pagination .page-item.active .page-link {\n  color: #fff;\n  background-color: #0CA751;\n}\n\n.pagination .page-item.disabled .page-link {\n  color: rgba(0, 0, 0, 0.45);\n  background-color: rgba(0, 0, 0, 0.03);\n  border: none;\n}\n\n.pagination .page-link {\n  padding: 4px 4px;\n  margin-left: 0px;\n  flex: auto;\n  color: rgba(0, 0, 0, 0.8);\n  background-color: rgba(0, 0, 0, 0.07);\n  border: none;\n  border-radius: 3px;\n  font-size: 14px;\n  min-width: 33px;\n  height: 29px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pagination  .page-link:hover {\n  z-index: 2;\n  color: #139B0E;\n  background-color:rgba(59, 213, 69, 0.10);\n}\n\n.pagination .page-link:focus {\n  z-index: 2;\n  outline: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  text-decoration: none;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n\n.pagination .page-link .visually-hidden{\n  display: none;\n}\n\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem;\n}\n\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem;\n}\n\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem;\n}\n\n/*\n* 5. UTILITIES\n*/\n.bg-primary {\n  background-color: #2186AD !important;\n}\n\na.bg-primary:focus,\na.bg-primary:hover {\n  background-color: #d13c4f !important;\n}\n\n.bg-secondary {\n  background-color: #868e96 !important;\n}\n\na.bg-secondary:focus,\na.bg-secondary:hover {\n  background-color: #6c757d !important;\n}\n\n.bg-success {\n  background-color: #20A701 !important;\n}\n\na.bg-success:focus,\na.bg-success:hover {\n  background-color: #27C603 !important;\n}\n\n.bg-info {\n  background-color: #08A9C6 !important;\n}\n\na.bg-info:focus,\na.bg-info:hover {\n  background-color: #117a8b !important;\n}\n\n.bg-warning {\n  background-color: #ffc107 !important;\n}\n\na.bg-warning:focus,\na.bg-warning:hover {\n  background-color: #d39e00 !important;\n}\n\n.bg-danger {\n  background-color: #E01A1A !important;\n}\n\na.bg-danger:focus,\na.bg-danger:hover {\n  background-color: #FC1212 !important;\n}\n\n.bg-light {\n  background-color: #e9ecef !important;\n}\n\na.bg-light:focus,\na.bg-light:hover {\n  background-color: #cbd3da !important;\n}\n\n.bg-dark {\n  background-color: #212529 !important;\n}\n\na.bg-dark:focus,\na.bg-dark:hover {\n  background-color: #0a0c0d !important;\n}\n\n.border-primary {\n  border-color: #2186AD !important;\n}\n\n.border-secondary {\n  border-color: #868e96 !important;\n}\n\n.border-success {\n  border-color: #28a745 !important;\n}\n\n.border-info {\n  border-color: #17a2b8 !important;\n}\n\n.border-warning {\n  border-color: #ffc107 !important;\n}\n\n.border-danger {\n  border-color: #bb414d !important;\n}\n\n.border-light {\n  border-color: #e9ecef !important;\n}\n\n.border-dark {\n  border-color: #212529 !important;\n}\n\n.text-primary {\n  color: #2186AD !important;\n}\n\na.text-primary:focus,\na.text-primary:hover {\n  color: #d13c4f !important;\n}\n\n.text-secondary {\n  color: #868e96 !important;\n}\n\na.text-secondary:focus,\na.text-secondary:hover {\n  color: #6c757d !important;\n}\n\n.text-success {\n  color: #28a745 !important;\n}\n\na.text-success:focus,\na.text-success:hover {\n  color: #1e7e34 !important;\n}\n\n.text-info {\n  color: #17a2b8 !important;\n}\n\na.text-info:focus,\na.text-info:hover {\n  color: #117a8b !important;\n}\n\n.text-warning {\n  color: #ffc107 !important;\n}\n\na.text-warning:focus,\na.text-warning:hover {\n  color: #d39e00 !important;\n}\n\n.text-danger {\n  color: #bb414d !important;\n}\n\na.text-danger:focus,\na.text-danger:hover {\n  color: #95343d !important;\n}\n\n.text-light {\n  color: #e9ecef !important;\n}\n\na.text-light:focus,\na.text-light:hover {\n  color: #cbd3da !important;\n}\n\n.text-dark {\n  color: #212529 !important;\n}\n\na.text-dark:focus,\na.text-dark:hover {\n  color: #0a0c0d !important;\n}\n\n.badge-primary {\n  color: color-yiq(#2186AD);\n  background-color: #2186AD;\n}\n\n.badge-primary[href]:focus,\n.badge-primary[href]:hover {\n  color: color-yiq(#2186AD);\n  text-decoration: none;\n  background-color: #d13c4f;\n}\n\n.badge-secondary {\n  color: color-yiq(#868e96);\n  background-color: #868e96;\n}\n\n.badge-secondary[href]:focus,\n.badge-secondary[href]:hover {\n  color: color-yiq(#868e96);\n  text-decoration: none;\n  background-color: #6c757d;\n}\n\n.badge-success {\n  color: color-yiq(#28a745);\n  background-color: #28a745;\n}\n\n.badge-success[href]:focus,\n.badge-success[href]:hover {\n  color: color-yiq(#28a745);\n  text-decoration: none;\n  background-color: #1e7e34;\n}\n\n.badge-info {\n  color: color-yiq(#17a2b8);\n  background-color: #17a2b8;\n}\n\n.badge-info[href]:focus,\n.badge-info[href]:hover {\n  color: color-yiq(#17a2b8);\n  text-decoration: none;\n  background-color: #117a8b;\n}\n\n.badge-warning {\n  color: color-yiq(#ffc107);\n  background-color: #ffc107;\n}\n\n.badge-warning[href]:focus,\n.badge-warning[href]:hover {\n  color: color-yiq(#ffc107);\n  text-decoration: none;\n  background-color: #d39e00;\n}\n\n.badge-danger {\n  color: color-yiq(#bb414d);\n  background-color: #bb414d;\n}\n\n.badge-danger[href]:focus,\n.badge-danger[href]:hover {\n  color: color-yiq(#bb414d);\n  text-decoration: none;\n  background-color: #95343d;\n}\n\n.badge-light {\n  color: color-yiq(#e9ecef);\n  background-color: #e9ecef;\n}\n\n.badge-light[href]:focus,\n.badge-light[href]:hover {\n  color: color-yiq(#e9ecef);\n  text-decoration: none;\n  background-color: #cbd3da;\n}\n\n.badge-dark {\n  color: color-yiq(#212529);\n  background-color: #212529;\n}\n\n.badge-dark[href]:focus,\n.badge-dark[href]:hover {\n  color: color-yiq(#212529);\n  text-decoration: none;\n  background-color: #0a0c0d;\n}\n\n/*\n* 6.CODE\n*/\ncode {\n  padding: 0.2rem 0.4rem;\n  font-size: 90%;\n  color: #2186AD;\n  background-color: #22252a;\n  border-radius: 0.25rem;\n}\n\na>code {\n  padding: 0;\n  color: inherit;\n  background-color: inherit;\n}\n\npre code {\n  background: none;\n}\n\n/*\n* 7. NAV\n*/\n.nav-link {\n  padding: 1rem 1rem;\n}\n\n.nav-link.disabled {\n  color: #868e96;\n}\n\n.nav-tabs .nav-item {\n  margin-bottom: -1px;\n}\n\n.nav-tabs .nav-link {\n  border: 1px solid transparent;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n\n.nav-tabs .nav-link:focus,\n.nav-tabs .nav-link:hover {\n  border-color: #34373d;\n}\n\n.nav-tabs .nav-link.disabled {\n  color: #868e96;\n}\n\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #8a8d93;\n  background-color: #22252a;\n  border-color: #34373d;\n}\n\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n}\n\n.nav-pills .nav-link {\n  border-radius: 0.25rem;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show>.nav-link {\n  color: #fff;\n  background-color: #2186AD;\n}\n\n/*\n* 8. CARD\n*/\n.card {\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  box-shadow: none;\n}\n\n.card>.list-group:first-child .list-group-item:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.card>.list-group:last-child .list-group-item:last-child {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.card-body {\n  padding: 1.25rem 20px;\n}\n\n.card-title {\n  margin-bottom: 0;\n}\n\n.card-subtitle {\n  margin-top: 0;\n}\n\n.card-link+.card-link {\n  margin-left: 1.25rem;\n}\n\n.card-header {\n  padding: 18px 20px;\n  background: transparent;\n  border-bottom: 1px solid rgb(212 212 212);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.card-header:first-child {\n  border-radius: 0 0 0 0;\n}\n\n.card-header-transparent {\n  background-color: rgba(0, 0, 0, 0.3);\n  border-bottom: none;\n}\n\n.card-header .cardTitle+.cardTitle {\n  margin-left: 60px;\n}\n\n.card-header .cardTitle h5 {\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.card-header .cardTitle p {\n  font-weight: 400;\n  font-size: 15px;\n  color: #717171;\n  line-height: 1.4;\n  margin: 5px 0 0 0;\n}\n\n.card-header .cardTitle .label {\n  font-weight: 500;\n  font-size: 16px;\n  color: rgba(0, 0, 0, 0.43);\n}\n\n.card-footer {\n  padding: 16px 20px;\n  background-color: transparent;\n  border-top: 1px solid #34373d;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.card-footer:last-child {\n  border-radius: 0 0 0 0;\n}\n\n.card-header-tabs {\n  margin-right: -0.625rem;\n  margin-bottom: -0.75rem;\n  margin-left: -0.625rem;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -0.625rem;\n  margin-left: -0.625rem;\n}\n\n.card-img-overlay {\n  padding: 1.25rem;\n}\n\n.card-img-overlay-opacity {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.card-img {\n  border-radius: 0;\n}\n\n.card-img-top {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.card-img-bottom {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.card-deck .card {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n  .card-deck {\n    margin-right: -15px;\n    margin-left: -15px;\n  }\n\n  .card-deck .card {\n    margin-right: 15px;\n    margin-left: 15px;\n  }\n}\n\n.card .list-group-item {\n  background: #2d3035;\n  border-color: #34373d;\n}\n\n.blue-color {\n  color: #007bff !important;\n}\n\n.blue-color:hover {\n  text-decoration: underline;\n}\n\n.table td,\n.table th {\n  border-color: #C9C7C7;\n  padding: 1rem;\n  vertical-align: middle;\n}\n\ntd .profileWrap .cont p {\n  max-width: 160px;\n  word-wrap: break-word;\n}\n\n.tableFilterWrap button.btn.btn-primary.mn-w-148.me-3 {\n  padding: 8px 14px;\n}\n\n@media (max-width: 599px) {\n  nav#sidebar {\n    top: 62px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
